<template>
  <div role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button :disabled="user.rol!='Admin'" block href="#" v-b-toggle.accordion-1 variant="secondary">
          <h5>
            <i class="far fa-building"></i> Opciones de Empresa
          </h5>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-container class="mt-4 mb-4" fluid>
          <b-card-group deck>
            <!-- logo -->
            <b-card>
              <template slot="header">
                <div class="display-5">
                  <i class="fa fa-cogs"></i> Opciones de Cuenta
                </div>
              </template>
              <template v-if="!cargarconfigacc">
                <b-form>
                  <div class="row">
                    <div class="col-sm-6 form-group">
                      <b-form-group label="RUC:">
                        <b-form-input type="text" v-model="user.idEmisor" readonly></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 form-group">
                      <b-form-group label="Razon Social:">
                        <b-form-input type="text" v-model="user.cuenta.razonSocial" readonly></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <b-form-group label="Nombre Comercial:">
                    <b-form-input type="text" v-model="user.cuenta.nombreComercial" readonly></b-form-input>
                  </b-form-group>

                  <b-form-group v-if="user.rol !== 'Admin'" label="Series:">
                    <b-form-input></b-form-input>
                  </b-form-group>
                  <b-row>
                    <b-col>
                      <b-form-group label="Logo Actual:">
                        <b-img :src="user.cuenta.uriImagen" fluid alt="Logo de Cuenta" />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group v-if="urlimg" label="Logo Nuevo:">
                        <b-img :src="urlimg" fluid alt="Logo de Cuenta" />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="6" md="5"	lg="5" xl="3">
                      <div class="">
                       <b-form-group label="Seleccionar IGV %">
                        <template v-if="cargandoIgv">
                          Cargando Igv... <i class="fa fa-spin fa-spinner"></i>
                        </template>
                        <template v-else>
                          <b-form-select v-model="selectedIGV" :options="optionsIGV"></b-form-select>
                        </template>
                       </b-form-group>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="5"	lg="8" xl="2">
                      <div>
                        <b-button 
                          class="botonIgv"
                          variant="primary" 
                          size="sm" 
                          @click="enviarIGV('primary')">
                          Guardar
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                   <b-col>
                    <em style="font-size: 12px; opacity: 0.7;">
                      Para aplicar los cambios (IGV%), vuelve a iniciar sesión.
                    </em>
                   </b-col>
                  </b-row>
                  <hr>
                  <b-row>
                    <template v-if="mostrarCodigoMtc == 1">
                      <b-col cols="12" sm="6" md="5"	lg="8" xl="3">
                       <div v-if="!mostrarMtc">
                         <b-form-group label="Cod. Entidad Emisora">
                          <select class="form-control input-placedark input-dark" 
                                v-model="indexEntidadEmisora"
                                :disabled="mostrarMtc">
                            <option
                                v-for="(entidad, index) in infoEntidadEmisora"
                                :value="index"
                                :key="index"
                            >{{ entidad.nombre }}</option>
                          </select>
                        </b-form-group>
                       </div>
                       <div v-else>
                         <b-form-group label="Cod. Entidad Emisora">
                          <select class="form-control input-placedark input-dark" 
                                v-model="autorizacionTransporteInfo.idEntidad"
                                :disabled="mostrarMtc">
                            <option
                                v-for="(entidad, index) in infoEntidadEmisora"
                                :value="index"
                                :key="index"
                            >{{ entidad.nombre }}</option>
                          </select>
                        </b-form-group>
                       </div>
                    </b-col>
                      <b-col cols="12" sm="6" md="5"	lg="8" xl="4">
                       <div v-if="!mostrarMtc">
                         <b-form-group label="Autorización Transportista">
                         <b-form-input 
                          :disabled="mostrarMtc"
                          v-model="autorizacionTransporte"
                          minlength="3"
                          maxlength="50">
                         </b-form-input>
                        </b-form-group>
                       </div>
                       <div v-else>
                         <b-form-group label="Autorización Transportista">
                         <b-form-input 
                          :disabled="mostrarMtc"
                          v-model="autorizacionTransporteInfo.autorizacionMtc"
                          minlength="3"
                          maxlength="50">
                         </b-form-input>
                        </b-form-group>
                       </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="5"	lg="8" xl="3">
                       <div v-if="!mostrarMtc">
                         <b-form-group label="Registro MTC">
                         <b-form-input 
                         :disabled="mostrarMtc"
                         v-model="nroAutorizacionTrasporte"
                         maxlength="20">
                         </b-form-input>
                        </b-form-group>
                       </div>
                       <div v-else>
                         <b-form-group label="Registro MTC">
                         <b-form-input 
                         :disabled="mostrarMtc"
                         v-model="autorizacionTransporteInfo.numeroPermiso"
                         maxlength="20">
                         </b-form-input>
                        </b-form-group>
                       </div>
                    </b-col>
                    <b-col>
                      <template v-if="!mostrarMtc">
                        <b-button 
                          class="botonIgv"
                          variant="warning"
                          size="sm"
                          @click="actualizarAutorizacion()">
                          Guardar
                        </b-button>
                        <b-button 
                        size="sm"
                        title="Cancelar"
                        style="margin-top:30%;margin-left:7%"
                        variant="ligth"
                        @click="cancelar()">
                          <i class="fa fa-times" aria-hidden="true"></i>
                        </b-button>
                      </template>
                      <template v-else>
                        <b-button 
                          class="botonIgv"
                          variant="primary"
                          size="sm"
                          @click="autorizacionMTC()">
                          Actualizar
                        </b-button>
                      </template>
                    </b-col>
                    </template>
                  </b-row>
                </b-form>
              </template>
              <template v-else>
                <b-row>
                  <b-col>
                    <h5 class="display-5 text-center">
                      <i class="fa fa-spin fa-spinner"></i> Cargando datos
                    </h5>
                  </b-col>
                </b-row>
              </template>
              <template slot="footer">
                <b-row v-if="user.rol == 'Admin'">
                  <b-col v-if="!changelogo" class="text-center">
                    <b-button size="sm" variant="primary" @click="changeimg()">
                      <i class="fa fa-cloud-upload"></i> Cambiar Logo
                    </b-button>
                  </b-col>
                  <b-col v-else class="text-center">
                    <b-row>
                      <b-col>
                        <b-form-file
                          v-model="logo"
                          :state="Boolean(logo)"
                          placeholder="Seleccione"
                          accept=".jpg, .png, .jpeg"
                          @change="onFileChange"
                        ></b-form-file>
                      </b-col>
                      <b-col>
                        <b-button
                          size="sm"
                          v-if="!savinglogo"
                          type="button"
                          class="btn btn-success"
                          @click="saveimg()"
                          :disabled="!Boolean(logo)"
                        >
                          <i class="fa fa-save"></i> Grabar
                        </b-button>
                        <b-button size="sm" v-else type="button" class="btn btn-secondary" disabled>
                          <i class="fa fa-spin fa-spinner"></i> Grabando
                        </b-button>
                      </b-col>
                      <b-col>
                        <b-button
                          size="sm"
                          v-if="!savinglogo"
                          type="button"
                          class="btn"
                          @click="changeimg()"
                        >
                          <i class="fa fa-times"></i> Cancelar
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
            </b-card>
            <!-- fin logo   -->
            <!-- direccion -->
            <b-card>
              <template slot="header">
                <div class="display-5">
                  <i class="fa fa-map-marker"></i> Opciones de Dirección
                </div>
              </template>
              <template v-if="!cargarconfigadd">
                <b-form>
                  <b-form-group label="Dirección:">
                    <b-form-input type="text" :value="user.cuenta.direccion.direccion" readonly></b-form-input>
                  </b-form-group>
                  <b-form-group label="Urbanización:">
                    <b-form-input type="text" :value="user.cuenta.direccion.urbanizacion" readonly></b-form-input>
                  </b-form-group>
                  <div class="row">
                    <div class="col-sm-4 form-group">
                      <b-form-group label="Departamento:">
                        <b-form-input
                          type="text"
                          :value="user.cuenta.direccion.departamento"
                          readonly
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 form-group">
                      <b-form-group label="Provincia:">
                        <b-form-input type="text" :value="user.cuenta.direccion.provincia" readonly></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4 form-group">
                      <b-form-group label="Distrito:">
                        <b-form-input type="text" :value="user.cuenta.direccion.distrito" readonly></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                </b-form>
              </template>
              <template v-else>
                <b-row>
                  <b-col>
                    <h5 class="display-5 text-center">
                      <i class="fa fa-spin fa-spinner"></i> Cargando datos
                    </h5>
                  </b-col>
                </b-row>
              </template>
              <b-row>
                <b-col>
                  Empresa de la Selva
                </b-col>
                <b-col>
                  <b-form-radio-group
                    v-model="amazonia"
                    :options="[
                      { text: 'Sí', value: 1 },
                      { text: 'No', value: 0 }
                    ]"
                    @change="configurarAmazonia"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <em></em>
                  <em style="font-size: 12px; opacity: 0.7;">
                    Para aplicar los cambios, vuelve a iniciar sesión.
                  </em>
                </b-col>
              </b-row>
              <template slot="footer">
                <template v-if="!cargarconfigadd2">
                  <b-button size="sm" variant="secondary" class="mr-3">
                    <i class="fa fa-times"></i> Cancelar
                  </b-button>
                  <b-button size="sm" variant="primary" @click="setConfigcode()">
                    <i class="fa fa-save"></i> Grabar
                  </b-button>
                </template>
                <template v-else>
                  <b-button size="sm" variant="secondary" disabled>
                    <i class="fa fa-spin fa-spinner"></i> Grabando
                  </b-button>
                </template>
              </template>
            </b-card>
            <!-- fin direccion -->
          </b-card-group>
        </b-container>
        <b-container class="mt4 mb-4" fluid>
          <!-- tiendas -->
          <b-card v-if="user.rol=='Admin'">
            <template slot="header">
              <i class="fa fa-building"></i> Direcciones
              <div class="float-right">
                <b-input-group prepend="Mostrar">
                  <b-form-select v-model="sperPage" @change="getStores()" :options="soptions" />
                </b-input-group>
              </div>
            </template>
            <template v-if="loadingstores">
              <b-row>
                <b-col class="text-center">
                  <h5 class="display-5">
                    <i class="fa fa-spin fa-spinner"></i> Cargando Tiendas
                  </h5>
                </b-col>
              </b-row>
            </template>
            <template v-else>
              <b-table striped hover :items="stores" :fields="storeitems">
                <template slot="index" slot-scope="data">{{data.index + 1}}</template>
                <template
                  slot="registro"
                  slot-scope="data"
                >{{data.item.created_at | moment('DD-MM-YYYY hh:mm:ss A')}}</template>
                <template slot="acciones" slot-scope="data">
                  <!-- <b-button-group v-if="data.item.codigoEstablecimiento!='0001'"> -->
                    <b-button variant="primary" @click="setStore(data.item)"><i class="fa fa-edit"></i></b-button>
                    <b-button variant="danger" @click="borrarEstablecimiento(data.item)"><i class="fa fa-trash"></i></b-button>
                  <!-- </b-button-group> -->
                </template>
              </b-table>
              <b-pagination
                v-model="scurrentPage"
                :per-page="sperPage"
                :total-rows="srows"
                size="sm"
                @input="getStores()"
                align="center"
              />
              <b-modal title="Nueva Tienda" size="lg" v-model="modalstore">
                <b-row>
                  <b-col>
                    <b-form-group label="Nombre de Tienda" :state="Boolean(namestore!=='')">
                      <b-form-input :state="Boolean(namestore!=='')" v-model.trim="namestore"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Código de Tienda" :state="Boolean(codestore!=='')">
                      <b-form-input :state="Boolean(codestore!=='')" v-model.trim="codestore"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- seleccionar ubigeo -->
                <b-row>
                  <b-col>
                    <label><b>Datos Ubigeo Partida</b></label>
                    <hr style="background-color:#D5E6FA; height:5px;">
                    <b-row>
                      <b-col>
                         <template>
                            <h5>Seleccione Departamento</h5>
                            <select class="custom-select mr-sm-2" v-model="departamentoUbigeo">
                                    <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{departamento.nombre}} </option>
                            </select>
                         </template>
                      </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                           <template>
                            <h5>Seleccione Provincia</h5>
                            <div v-if="!provOrigen">
                               <b-form-input 
                                    type="text"
                                    disabled
                                    placeholder="Selecciona una Provincia...">
                                </b-form-input>
                            </div>
                            <div v-else-if="provOrigenCargando">
                                    Cargando <i class="fa fa-spin fa-spinner"></i>
                            </div>
                            <div v-else>
                            <select class="custom-select mr-sm-2" v-model="provinciaUbigeo" >
                                    <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                            </select>
                            </div>
                         </template>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                          <template>
                            <h5>Seleccione Distrito</h5>
                            <div v-if="!distOrigen">
                                    <b-form-input 
                                        type="text"
                                        disabled
                                        placeholder="Selecciona una Distrito...">
                                    </b-form-input>
                            </div>
                            <div v-else-if="distOrigenCargando">
                                   Cargando <i class="fa fa-spin fa-spinner"></i>
                            </div>
                            <div v-else>
                            <select class="custom-select mr-sm-2"  v-model="distritoUbigeo">
                                    <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{distrito.nombre}}</option>
                            </select>
                            </div>
                          </template>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col cols="3">
                          <template>
                            <b-form-input disabled placeholder="codigo ubigeo partida" v-model="ubigeoPartida"></b-form-input>
                          </template>
                        </b-col>
                        <b-col cols="9">
                          <template>
                            <b-form-input  maxlength="100" placeholder="Direccion de partida" v-model="direcUbigeo"></b-form-input>
                          </template>
                        </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                  <!-- FIN seleccionar ubigeo -->
                <template slot="modal-footer">
                  <div>
                    <template v-if="!loadingstores2">
                      <b-button class="mr-2" @click="modalstore = false">
                        <i class="fa fa-times"></i> Cancelar
                      </b-button>
                      <b-button
                        variant="primary"
                        @click="saveStore()"
                        :disabled="!Boolean(namestore!=='' && codestore!=='' && ubigeoPartida!==''&& direcUbigeo!=='')"
                      >
                        <i class="fa fa-save"></i> Grabar
                      </b-button>
                    </template>
                    <template v-else>
                      <b-button variant="secondary" disabled>
                        <i class="fa fa-spin fa-spinner"></i> Grabando
                      </b-button>
                    </template>
                  </div>
                </template>
              </b-modal>
              <b-modal title="Editar Tienda" size="lg" v-model="modalupdate">
                <b-row>
                  <b-col>
                    <b-form-group label="Nombre de Tienda" :state="Boolean(namestore!=='')">
                      <b-form-input
                        :state="Boolean(editnamestore!=='')"
                        v-model.trim="editnamestore"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                   <b-col>
                    <b-form-group label="Código de Tienda" :state="Boolean(codestore!=='')">
                      <b-form-input
                        :state="Boolean(editcodestore!=='')"
                        v-model.trim="editcodestore"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                 <!-- seleccionar ubigeo -->
                <b-row>
                  <b-col>
                    <label><b>Datos Ubigeo Partida</b></label>
                    <hr style="background-color:#D5E6FA; height:5px;">
                    <b-row>
                      <b-col>
                         <template>
                            <h5>Seleccione Departamento</h5>
                            <select class="custom-select mr-sm-2" v-model="departamentoUbigeo">
                                    <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{departamento.nombre}} </option>
                            </select>
                         </template>
                      </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                           <template>
                            <h5>Seleccione Provincia</h5>
                            <div v-if="!provOrigen">
                               <b-form-input 
                                    type="text"
                                    disabled
                                    placeholder="Selecciona una Provincia...">
                                </b-form-input>
                            </div>
                            <div v-else-if="provOrigenCargando">
                                    Cargando <i class="fa fa-spin fa-spinner"></i>
                            </div>
                            <div v-else>
                            <select class="custom-select mr-sm-2" v-model="provinciaUbigeo" >
                                    <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                            </select>
                            </div>
                         </template>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                          <template>
                            <h5>Seleccione Distrito</h5>
                            <div v-if="!distOrigen">
                                    <b-form-input 
                                        type="text"
                                        disabled
                                        placeholder="Selecciona una Distrito...">
                                    </b-form-input>
                            </div>
                            <div v-else-if="distOrigenCargando">
                                   Cargando <i class="fa fa-spin fa-spinner"></i>
                            </div>
                            <div v-else>
                            <select class="custom-select mr-sm-2"  v-model="distritoUbigeo">
                                    <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{distrito.nombre}}</option>
                            </select>
                            </div>
                          </template>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col cols="3">
                          <template>
                            <b-form-input disabled placeholder="codigo ubigeo partida" v-model="ubigeoPartida"></b-form-input>
                          </template>
                        </b-col>
                        <b-col cols="9">
                          <template>
                            <b-form-input  maxlength="100" placeholder="Direccion de partida" v-model="direcUbigeo"></b-form-input>
                          </template>
                        </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                 <!-- FIN seleccionar ubigeo -->
                <template slot="modal-footer">
                  <div>
                    <template v-if="!loadingstores3">
                      <b-button class="mr-2" @click="modalupdate = false">
                        <i class="fa fa-times"></i> Cancelar
                      </b-button>
                      <b-button
                        variant="primary"
                        @click="updateStore()"
                        :disabled="!Boolean(editnamestore!=='' && editcodestore!=='')"
                      >
                        <i class="fa fa-save"></i> Actualizar
                      </b-button>
                    </template>
                    <template v-else>
                      <b-button variant="secondary" disabled>
                        <i class="fa fa-spin fa-spinner"></i> Actualizando
                      </b-button>
                    </template>
                  </div>
                </template>
              </b-modal>
            </template>
            <template slot="footer">
              <div class="animated fadeIn">
                <b-button type="button" variant="primary" @click="modalstore = true">
                  <i class="fa fa-plus"></i> Agregar
                </b-button>
              </div>
            </template>
          </b-card>
          <!-- fin tiendas -->
        </b-container>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button :disabled="user.rol!='Admin'" block href="#" v-b-toggle.accordion-2 variant="secondary">
          <h5>
            <i class="fas fa-key"></i> Cambiar Contraseña
          </h5>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-container class="mt-4 mb-4">
          <!-- <b-card-group deck> -->
          <!-- datos usuario -- >
                   <b-card>
                            <template slot="header" class="card-header">
                              <i class="fa fa-user"></i> Datos de Usuario
                            </template>
                            <b-form-row>
                              <b-col>
                                <b-form-group label="Apellido Paterno">
                                  <b-form-input v-model.trim="user.perfil.appUsuario"></b-form-input>
                                </b-form-group>
                              </b-col>
                              <b-col>
                                <b-form-group label="Apellido Materno">
                                  <b-form-input v-model.trim="user.perfil.apmUsuario"></b-form-input>
                                </b-form-group>
                              </b-col>
                            </b-form-row>
                            <b-form-row>
                              <b-col>
                                <b-form-group label="Nombres">
                                  <b-form-input v-model.trim="user.perfil.nomUsuario"></b-form-input>
                                </b-form-group>
                              </b-col>
                              <b-col>
                                <b-form-group label="Correo">
                                  <b-form-input v-model.trim="user.perfil.emailUsuario"></b-form-input>
                                </b-form-group>
                              </b-col>
                            </b-form-row>
                            <b-row class="text-center">
                              <b-col>
                                <b-img rounded height="100" :src="user.perfil.image"/>
                              </b-col>
                            </b-row>
                            <b-row class="text-center">
                              <b-col>
                                {{ user.username }}
                              </b-col>
                            </b-row>
                            <template slot="footer">
                              <b-button variant="primary"><i class="fa fa-save"></i>  Grabar</b-button>
                            </template>
                         </b-card>
          <!-- fin usuario no funcional-->

          <!-- contraseña -->

          <b-card style="width:50%; margin-left:24%" >
            <template slot="header">
              <i class="fa fa-key"></i> Contraseña
            </template>
              <template v-if="change">
              <b-row>
                <b-col cols="2"></b-col>
                <b-col cols="8">
                <b-form>
                  <b-form-group label="Contraseña Nueva:" description>
                    <b-form-input name="password" id="password"
                      v-model="personalizar.claveNueva1"
                      type="password"
                      :state="validarPassword()"
                      required
                    ></b-form-input>
                    <b-form-invalid-feedback>Ingrese una clave</b-form-invalid-feedback>
                      <b-form-checkbox v-model="longitud">Longitud mayor o igual que 6 caracteres</b-form-checkbox>
                      <b-form-checkbox v-model="mayus">Carácter en mayúsculas</b-form-checkbox>
                      <b-form-checkbox v-model="minus">Carácter en minúsculas</b-form-checkbox>
                      <b-form-checkbox v-model="number">Carácter numérico</b-form-checkbox>
                  </b-form-group>
                  <b-form-group label="Repetir Contraseña:" description>
                    <b-form-input name="password2" id="password2"
                      v-model="personalizar.claveNueva2"
                      type="password"
                      :state="checkpwd2()"
                      required
                    ></b-form-input>
                    <b-form-invalid-feedback>Las contraseñas con coinciden</b-form-invalid-feedback>
                  </b-form-group>
                  Mostrar contraseña <b-button variant="gray" class="btn-sm sinresultados" title="Mostrar contraseña" @click="mostrarPassword()"><i class="fas fa-eye"></i></b-button>
                </b-form>
                </b-col>
                 <b-col cols="2"></b-col>
              </b-row>  
              </template>
            <template v-else>
              <div class="text-center">
                <b-button size="sm" type="button" @click="changepwd()" class="btn btn-info">
                  <i class="fa fa-refresh"></i> Cambiar
                </b-button>
              </div>
            </template>
            <template slot="footer" v-if="change">
              <template v-if="loading">
                <b-button size="sm" variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Procesando
                </b-button>
              </template>
              <template v-else>
                <template v-if="btnenabled()">
                  <b-button size="sm" @click="sendNewPass()" variant="primary">
                    <i class="fa fa-save"></i> Grabar
                  </b-button>
                  <b-button size="sm" variant="warning" @click="changepwd()" class="ml-4">
                    <i class="fa fa-times"></i> Cancelar
                  </b-button>
                </template>
                <template v-else>
                  <b-button size="sm" variant="secondary" disabled>
                    <i class="fa fa-save"></i> Grabar
                  </b-button>
                  <b-button size="sm" variant="warning" @click="changepwd()" class="ml-4">
                    <i class="fa fa-times"></i> Cancelar
                  </b-button>
                </template>
              </template>
            </template>
          </b-card>
          <!-- fin contraseña -->
          <!-- </b-card-group>  -->
        </b-container>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button :disabled="user.rol!='Admin'" block href="#" v-b-toggle.accordion-3 variant="secondary">
          <h5>
            <i class="fas fa-university"></i> Configurar Cuentas Corrientes
          </h5>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-container class="mt-4 mb-4" fluid>
          <!-- cta detrac -->
          <b-card>
            <template slot="header">
              <i class="fa fa-money"></i> Cuenta de Detracción
            </template>
            <template>
              <b-form-row>
                <b-col cols="12">
                  <!-- Simpre saldra al inicion cargando aunque no halla cta detraccion -->
                  <template v-if="!buscandoCtaDetraccion">
                    Buscando Cuenta de detraccion
                    <i class="fa fa-spin fa-spinner"></i>
                  </template>
                  <!-- Encuentre la cta o no entra a este bloque -->
                  <template v-else>
                    <!-- Si se encontro la cuenta de detraccion -->
                    <template v-if="detraccionExiste">
                      Su cuenta de detraccion es:
                      <strong>{{ cuentaDetracionAdmin }}</strong>
                    </template>
                    <!-- Si no se hallo la cuenta de detraccion -->
                    <template v-else>
                      <!-- Añadir nueva cuenta de detraccion -->
                      <b-form-group
                        v-if="crearCuentaDetraccion"
                        label="Añadir cuenta de detracción"
                      >
                        <b-row align-v="center">
                          <b-col cols="12">
                            <template>
                              <b-form-input v-model.trim="cuentaDetraccion"></b-form-input>
                            </template>
                          </b-col>
                        </b-row>
                      </b-form-group>
                      <!-- Modificar la cta que ya existe -->
                      <b-form-group v-else label="Modificar cuenta de detraccion">
                        <b-row align-v="center">
                          <b-col cols="12">
                            <template>
                              <b-form-input v-model.trim="cuentaDetraccion"></b-form-input>
                            </template>
                          </b-col>
                        </b-row>
                      </b-form-group>
                      <b-row>
                        <b-col cols="12">
                          <small>
                            <em>La cuenta debe tener la forma: 00-021-062359</em>
                          </small>
                        </b-col>
                      </b-row>
                    </template>
                  </template>
                </b-col>
              </b-form-row>
            </template>
            <!-- Los botones de accion -->
            <template slot="footer">
              <div class="animated fadeIn">
                <!-- Crear una nueva cuenta de detraccion -->
                <template v-if="botonesDetraccionExiste">
                  <b-button
                    type="button"
                    variant="primary"
                    v-if="agregandoCuentaDet"
                    @click="addAccountDetraction(1)"
                  >
                    <i class="fa fa-plus"></i> Agregar
                  </b-button>
                  <b-button type="button" variant="secondary" v-else>
                    <i class="fa fa-spin fa-spinner"></i> Agregando...
                  </b-button>
                </template>
                <!-- Modificar la que ya existe -->
                <template v-else>
                  <!-- Vista previa a modificar -->
                  <template v-if="previoModificar">
                    <b-button
                      size="sm"
                      type="button"
                      v-if="vistaModificar"
                      variant="warning"
                      @click="backModify(1)"
                    >
                      <i class="fa fa-refresh"></i> Cambiar
                    </b-button>
                    <b-button size="sm" v-else type="button" variant="secondary" disabled>
                      <i class="fa fa-plus"></i> Agregar
                    </b-button>
                  </template>
                  <!-- Modificar cuenta -->
                  <template v-else>
                    <b-button
                      type="button"
                      size="sm"
                      variant="warning"
                      v-if="!modificando"
                      @click="updateAccountDetraction"
                    >
                      <i class="fa fa-edit"></i> Modificar
                    </b-button>
                    <b-button type="button" size="sm" variant="warning" v-else disabled>
                      <i class="fa fa-spin fa-spinner"></i> Modificando
                    </b-button>
                    <b-button
                      type="button"
                      size="sm"
                      variant="danger"
                      @click="backModify(0)"
                      class="styleback ml-4"
                    >
                      <i class="fa fa-back"></i> Atras
                    </b-button>
                  </template>
                </template>
              </div>
            </template>
          </b-card>
          <!-- fin cta detraccion -->
          <!-- cta corriente pagos -->
          <b-card>
            <template slot="header">
              <i class="fa fa-edit"></i> Información para pagos
            </template>
            <template>
              <b-table
                responsive
                small
                outlined
                striped
                :items="listaBancos"
                :busy="isBusy"
                :fields="banco_fields"
              >
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Cargando...</strong>
                </div>
                <template slot="acciones" slot-scope="row">
                  <b-button
                    v-b-modal.modaladdbank1
                    size="sm"
                    variant="primary"
                    @click="setUpdateBank(row.item)"
                  >
                    <i class="fa fa-pencil-alt"></i>
                  </b-button>
                  <b-button
                    size="sm"
                    variant="danger"
                    class="ml-1"
                    @click="predeleteBank(row.item)"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </template>
            <template slot="footer">
              <div class="animated fadeIn">
                <template>
                  <b-button
                    size="sm"
                    v-b-modal.modaladdbank1
                    variant="primary"
                    @click="setActualizar"
                  >
                    <i class="fa fa-plus"></i> Agregar
                  </b-button>
                </template>
              </div>
              <b-modal id="modaladdbank1" title="Registrar Nuevo Banco" size="lg" v-model="addbank">
                <b-row>
                  <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <select
                      v-if="banco.id != 13"
                      class="custom-select mr-sm-2 input-placedark input-dark"
                      v-model="banco"
                    >
                      <option
                        :value="banco"
                        v-for="banco in Bancos"
                        v-bind:key="banco.id"
                      >{{ banco.descripcion }}</option>
                    </select>
                    <b-input-group v-else-if="banco.id == 13">
                      <b-form-input v-model="otrobanco" placeholder="Ingrese nombre del banco" />
                      <b-input-group-text slot="append">
                        <b-button
                          size="sm"
                          class="m-0 p-0 pl-2 pr-2"
                          @click="closeNameBank"
                          variant="warning"
                        >
                          <i class="fa fa-times text-dark"></i>
                        </b-button>
                      </b-input-group-text>
                    </b-input-group>
                  </b-col>
                  <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <select
                      v-if="cuenta.id != 5"
                      class="custom-select mr-sm-2 input-placedark input-dark"
                      v-model="cuenta"
                    >
                      <option
                        :value="cuenta"
                        v-for="cuenta in Cuentas"
                        v-bind:key="cuenta.id"
                      >{{ cuenta.descripcion }}</option>
                    </select>
                    <b-input-group v-else-if="cuenta.id == 5">
                      <b-form-input v-model="otracuenta" placeholder="Ingrese el tipo de cuenta" />
                      <b-input-group-text slot="append">
                        <b-button
                          size="sm"
                          class="m-0 p-0 pl-2 pr-2"
                          @click="closeNameCuenta"
                          variant="warning"
                        >
                          <i class="fa fa-times text-dark"></i>
                        </b-button>
                      </b-input-group-text>
                    </b-input-group>
                  </b-col>
                  <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <select
                      class="custom-select mr-sm-2 input-placedark input-dark"
                      v-model="tipodemoneda"
                    >
                      <option
                        :value="moneda"
                        v-for="moneda in tipoMoneda"
                        v-bind:key="moneda.id"
                      >{{ moneda.descripcion }}</option>
                    </select>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <b-form-input v-model="numerocuenta" placeholder="Ingrese numero de cuenta" />
                  </b-col>
                  <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <b-form-input v-model="cci" placeholder="Ingrese el codigo interbancario" />
                  </b-col>
                </b-row>
                <template slot="modal-footer">
                  <div>
                    <template>
                      <template v-if="!actualizar">
                        <b-button
                          size="sm"
                          variant="primary"
                          v-if="emitiendobank"
                          :disabled="validbancoguardar"
                          @click="addupdateBank(1)"
                        >
                          <i class="fa fa-save"></i> Guardar
                        </b-button>
                        <b-button size="sm" variant="primary" v-else disabled>
                          <i class="fa fa-spin fa-spinner"></i> Guardando...
                        </b-button>
                      </template>
                      <template v-else>
                        <b-button
                          v-b-modal.modaladdbank1
                          size="sm"
                          v-if="actualizandobank"
                          variant="warning"
                          :disabled="!validateUpdateBank()"
                          @click="addupdateBank(2)"
                        >
                          <i class="fa fa-save"></i> Actualizar
                        </b-button>
                        <b-button size="sm" variant="warning" v-else disabled>
                          <i class="fa fa-spin fa-spinner"></i> Actualizando...
                        </b-button>
                      </template>
                      <b-button size="sm" variant="danger" class="ml-2" @click="cerrarModalBanco">
                        <i class="fa fa-times"></i> Cerrar
                      </b-button>
                    </template>
                  </div>
                </template>
              </b-modal>
            </template>
          </b-card>
          <!-- fin cta corriente -->
        </b-container>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button :disabled="user.rol!='Admin'" block href="#" v-b-toggle.accordion-4 variant="secondary">
          <h5>
            <i class="fas fa-file-invoice-dollar"></i> Administrar Series y Usuarios para Facturación
          </h5>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-4" v-model="visible" accordion="my-accordion" role="tabpanel">
        <b-container class="mt-4 mb-4" fluid>
          <b-card-group deck>
            <!-- series -->
            <b-card header-tag="header">
              <template slot="header">
                <div class="display-5">
                  <i class="fa fa-list-ol"></i> Series
                </div>
              </template>
              <template>
                <b-card no-body>
                  <b-tabs pills card vertical nav-wrapper-class="w-35" v-model="tabIndex">
                    <b-tab title="Facturas" active>
                      <template v-if="series.type1.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :per-page="series.type1.info.limit"
                              :items="series.type1.info.data"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(1,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button 
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(1,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(1)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type1.info.total"
                                v-model="series.type1.info.currentpage"
                                :per-page="series.type1.info.limit"
                                @input="getSeriesbyType(1)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Boletas de Venta">
                      <template v-if="series.type2.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type2.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(2,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(2,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(2)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type2.info.total"
                                v-model="series.type2.info.currentpage"
                                :per-page="series.type2.info.limit"
                                @input="getSeriesbyType(2)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Notas de Crédito - Facturas">
                      <template v-if="series.type3.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type3.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(3,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(3,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(3)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type3.info.total"
                                v-model="series.type3.info.currentpage"
                                :per-page="series.type3.info.limit"
                                @input="getSeriesbyType(3)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Notas de Crédito - Boletas">
                      <template v-if="series.type4.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type4.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(4,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(4,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(4)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type4.info.total"
                                v-model="series.type4.info.currentpage"
                                :per-page="series.type4.info.limit"
                                @input="getSeriesbyType(4)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Notas de Débito - Facturas">
                      <template v-if="series.type5.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type5.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(5,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(5,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(5)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type5.info.total"
                                v-model="series.type5.info.currentpage"
                                :per-page="series.type5.info.limit"
                                @input="getSeriesbyType(5)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Notas de Débito - Boletas">
                      <template v-if="series.type6.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type6.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(6,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(6,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(6)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type6.info.total"
                                v-model="series.type6.info.currentpage"
                                :per-page="series.type6.info.limit"
                                @input="getSeriesbyType(6)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Guías de Remisión">
                      <template v-if="series.type7.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type7.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(7,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(7,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(7)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type7.info.total"
                                v-model="series.type7.info.currentpage"
                                :per-page="series.type7.info.limit"
                                @input="getSeriesbyType(7)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Proformas">
                      <template v-if="series.type8.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type8.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(8,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(8,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(8)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type8.info.total"
                                v-model="series.type8.info.currentpage"
                                :per-page="series.type8.info.limit"
                                @input="getSeriesbyType(8)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Orden de Compra">
                      <template v-if="series.type9.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type9.info.data"
                              
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(9,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(9,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(9)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type9.info.total"
                                v-model="series.type9.info.currentpage"
                                :per-page="series.type9.info.limit"
                                @input="getSeriesbyType(9)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Guía de Control">
                      <template v-if="series.type10.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type10.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(10,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(10,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(10)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type10.info.total"
                                v-model="series.type10.info.currentpage"
                                :per-page="series.type10.info.limit"
                                @input="getSeriesbyType(10)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>               
                    <b-tab title="Orden de Pago">
                      <template v-if="series.type11.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type11.info.data"
                              :per-page="series.type11.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(11,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(11,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(11)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type11.info.total"
                                v-model="series.type11.info.currentpage"
                                :per-page="series.type11.info.limit"
                                @input="getSeriesbyType(11)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Nota de Venta">
                      <template v-if="series.type12.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type12.info.data"
                              :per-page="series.type12.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(12,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(12,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(12)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type12.info.total"
                                v-model="series.type12.info.currentpage"
                                :per-page="series.type12.info.limit"
                                @input="getSeriesbyType(12)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab v-if="this.$store.getters.guiaTransportista == 1" title="Guía Transportista">
                      <template v-if="series.type13.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type13.info.data"
                              :per-page="series.type13.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(13,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(13,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(13)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type13.info.total"
                                v-model="series.type13.info.currentpage"
                                :per-page="series.type13.info.limit"
                                @input="getSeriesbyType(13)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Ticket Suministro">
                      <template v-if="series.type14.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type14.info.data"
                              :per-page="series.type14.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(14,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(14,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(14)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type14.info.total"
                                v-model="series.type14.info.currentpage"
                                :per-page="series.type14.info.limit"
                                @input="getSeriesbyType(14)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>

                    <b-tab title="Percepciones" disabled>Tab Contents</b-tab>
                    <b-tab title="Retenciones" disabled>Tab Contents 11</b-tab>
                  </b-tabs>
                </b-card>
              </template>
            </b-card>
            <b-modal v-model="modalserie" title="Agregar Serie">
              <b-row>
                <b-col>
                  <b-form-group label="COMPROBANTE">
                    <b-input-group>
                      <b-form-select
                        v-model="typecomprobant"
                        :options="comprobants"
                        :value-field="'value'"
                        :text-field="'name'"
                        readonly
                      />
                      <b-input-group-append>
                        <b-btn variant="secondary">
                          <i class="fa fa-file-text-o"></i>
                        </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Serie">
                    <b-input-group :prepend="getPrefixDoc(typecomprobant)">
                      <b-form-input type="text" v-model="serie" maxlength="3"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Inicial">
                    <b-input-group prepend="#">
                      <b-form-input type="number" v-model="startin"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <template slot="modal-footer">
                <div>
                  <template v-if="cargarconfigserie">
                    <b-button variant="secondary" class="disabled">
                      <i class="fa fa-spin fa-spinner"></i> Grabando
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button variant="secondary mr-1" @click="modalserie=false">
                      <i class="fa fa-times"></i> Cancelar
                    </b-button>
                    <b-button  :disabled="validarSerie" variant="primary" @click="storeSerie()">
                      <i class="fa fa-save"></i> Grabar
                    </b-button>
                  </template>
                </div>
              </template>
            </b-modal>
            <b-modal v-model="modalserieupdate" title="Editar Serie">
              <b-row>
                <b-col>
                  <b-form-group label="COMPROBANTE">
                    <b-input-group>
                      <b-form-select
                        v-model="typecomprobant2"
                        :options="comprobants"
                        :value-field="'value'"
                        :text-field="'name'"
                        disabled
                      />
                      <b-input-group-append>
                        <b-btn variant="secondary">
                          <i class="fa fa-file-text-o"></i>
                        </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Serie">
                    <b-input-group :prepend="getPrefixDoc(typecomprobant2)">
                      <b-form-input type="text" v-model="serie2" maxlength="3"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Inicial">
                    <b-input-group prepend="#">
                      <b-form-input type="number" v-model="startin2"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <template slot="modal-footer">
                <div>
                  <template v-if="cargarconfigserie2">
                    <b-button variant="secondary" class="disabled">
                      <i class="fa fa-spin fa-spinner"></i> Grabando
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button class="float-right" variant="secondary" @click="modalserieupdate=false">
                      <i class="fa fa-times"></i> Cancelar
                    </b-button>
                    <b-button class="float-right mr-3" variant="primary" @click="updateSerie()">
                      <i class="fa fa-save"></i> Grabar
                    </b-button>
                      <b-form-checkbox class="float-right mr-5" v-model="mostrarSerie"> Mostrar serie para emitir</b-form-checkbox> 
                  </template>
                </div>
              </template>
            </b-modal>
            <b-modal centered v-model="modalseriedelete" title="Eliminar Serie">
              <div class="text-center">
                <h5 class="my-auto">
                  Desea Eliminar la Serie
                  <b>{{' '+ serie3 +' '}}</b> ?
                </h5>
              </div>
              <template slot="modal-footer">
                <div>
                  <template v-if="cargarconfigserie3">
                    <b-button variant="secondary" class="disabled">
                      <i class="fa fa-spin fa-spinner"></i> Eliminando
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button variant="secondary mr-1" @click="modalseriedelete=false">
                      <i class="fa fa-times"></i> Cancelar
                    </b-button>
                    <b-button variant="danger" @click="deleteSerie()">
                      <i class="fa fa-trash"></i> Eliminar
                    </b-button>
                  </template>
                </div>
              </template>
            </b-modal>
            <!-- fin series -->
          </b-card-group>
        </b-container>
        <b-container class="mt-4 mb-4" fluid>
          <!-- lista de usuarios -->
          <b-card v-if="user.rol=='Admin'">
            <template slot="header">
              <i class="fa fa-users"></i> Usuarios
              <div class="float-right">
                <b-input-group prepend="Mostrar">
                  <b-form-select v-model="uperPage" @change="getUsers()" :options="uoptions" />
                </b-input-group>
              </div>
            </template>
            <template v-if="loadingusers">
              <b-row>
                <b-col class="text-center">
                  <h5 class="display-5">
                    <i class="fa fa-spin fa-spinner"></i> Cargando Usuarios
                  </h5>
                </b-col>
              </b-row>
            </template>
            <template v-else>
              <b-table striped hover :items="users" :fields="useritems">
                <template slot="index" slot-scope="data">{{data.index + 1}}</template>
                <template
                  slot="registro"
                  slot-scope="data"
                >{{data.item.fechaCreacion | moment('DD-MM-YYYY hh:mm:ss A')}}</template>
                <template slot="acciones" slot-scope="data">
                  <b-button-group v-if="data.item.codigoEstablecimiento!='0001'">
                    <b-button title="Actualizar" size="sm" @click="getUser(data.item)">
                      <i class="fa fa-edit"></i>
                    </b-button>
                    <!-- <b-button>
                              <i class="fa fa-trash"></i>
                    </b-button>-->
                  </b-button-group>
                </template>
              </b-table>
              <b-pagination
                v-model="ucurrentPage"
                :per-page="uperPage"
                :total-rows="urows"
                size="sm"
                @input="getUsers()"
                align="center"
              />
              <b-modal title="Nuevo Usuario" size="lg" v-model="modaluser" @ok="largeModal = false">
                <b-tabs>
                  <b-tab title="Datos Generales">
                    <b-row>
                      <div class="col-sm-4 form-group">
                        <label>Nombre de Usuario</label>
                        <input type="text" v-model="newuser.username" class="form-control" />
                      </div>
                      <div class="col-sm-4 form-group">
                        <label>Rol</label>
                        <template v-if="servicioConta">
                          <select class="custom-select mr-sm-2" v-model="newuser.perfil.rol">
                            <template v-for="item in roleusers2">
                              <option :value="item.value">{{item.text}}</option>
                            </template>
                          </select>
                        </template>
                        <template v-else>
                          <select class="custom-select mr-sm-2" v-model="newuser.perfil.rol">
                            <template v-for="item in roleusers">
                              <option :value="item.value">{{item.text}}</option>
                            </template>
                          </select>
                        </template>
                      </div>
                      <div class="col-sm-4 form-group">
                        <label>Tienda</label>
                        <select
                          class="custom-select mr-sm-2"
                          v-model="newuser.perfil.establecimiento"
                        >
                          <template v-for="item in stores">
                            <option :value="item.idEstablecimiento">{{item.nombreEstablecimiento}}</option>
                          </template>
                        </select>
                      </div>
                    </b-row>
                    <b-row>
                      <div class="col-sm-6 form-group">
                        <label>Apellido Paterno</label>
                        <input type="text" class="form-control" v-model="newuser.perfil.appUsuario" />
                      </div>
                      <div class="col-sm-6 form-group">
                        <label>Apellido Materno</label>
                        <input type="text" class="form-control" v-model="newuser.perfil.apmUsuario" />
                      </div>
                    </b-row>
                    <b-row>
                      <b-col>
                        <div class="form-group">
                          <label>Nombres</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="newuser.perfil.nomUsuario"
                          />
                        </div>
                      </b-col>
                      <b-col>
                        <div class="form-group">
                          <label>Correo</label>
                          <input type="text" class="form-control" v-model="newuser.perfil.correo" />
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Asignar Series" v-if="newuser.perfil.rol != 3 && newuser.perfil.rol != 1">
                    <template v-if="loadingseries">
                      <b-row>
                        <b-col class="text-center">
                          <h5 class="display-5">
                            <i class="fa fa-spin fa-spinner"></i> Cargando Series
                          </h5>
                        </b-col>
                      </b-row>
                    </template>
                    <template v-else>
                      <div class="row">
                        <b-col>
                          <b-form-group label="Facturas">
                            <b-form-checkbox-group v-model="seriesfacturas">
                              <template v-for="elem in seriesall[1]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Boletas">
                            <b-form-checkbox-group v-model="seriesboletas">
                              <template v-for="elem in seriesall[2]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.C. Facturas">
                            <b-form-checkbox-group v-model="seriesnotascf">
                              <template v-for="elem in seriesall[3]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.C. Boletas">
                            <b-form-checkbox-group v-model="seriesnotascb">
                              <template v-for="elem in seriesall[4]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.D. Facturas">
                            <b-form-checkbox-group v-model="seriesnotasdf">
                              <template v-for="elem in seriesall[5]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.D. Boletas">
                            <b-form-checkbox-group v-model="seriesnotasdb">
                              <template v-for="elem in seriesall[6]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Guías de R.">
                            <b-form-checkbox-group v-model="seriesgr">
                              <template v-for="elem in seriesall[7]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Guías de C.">
                            <b-form-checkbox-group v-model="seriesgc">
                              <template v-for="elem in seriesall[10]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Proforma">
                            <b-form-checkbox-group v-model="seriesp">
                              <template v-for="elem in seriesall[8]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Orden C">
                            <b-form-checkbox-group v-model="seriesoc">
                              <template v-for="elem in seriesall[9]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Orden P">
                            <b-form-checkbox-group v-model="seriesop">
                              <template v-for="elem in seriesall[11]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Nota Venta">
                            <b-form-checkbox-group v-model="seriesnv">
                              <template v-for="elem in seriesall[12]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col v-if="mostrarOcultarGuia == 1">
                          <b-form-group label="Guias Transp.">
                            <b-form-checkbox-group v-model="seriesgt">
                              <template v-for="elem in seriesall[13]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Ticket Suministro">
                            <b-form-checkbox-group v-model="seriests">
                              <template v-for="elem in seriesall[14]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                      </div>
                    </template>
                  </b-tab>
                </b-tabs>
                <template slot="modal-footer">
                  <template v-if="loadinguser">
                    <b-button type="button" variant="secondary" class="mr-1 disabled">
                      <i class="fa fa-spin fa-spinner"></i> Grabando
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button
                      type="button"
                      variant="secondary"
                      class="mr-1 disabled"
                      @click="modaluser=false"
                    >
                      <i class="fa fa-times"></i> Cerrar
                    </b-button>
                    <b-button type="button" variant="primary" @click="storeUser()" class="mr-1">
                      <i class="fa fa-save"></i> Grabar
                    </b-button>
                  </template>
                </template>
              </b-modal>
              <b-modal
                title="Editar Usuario"
                size="lg"
                v-model="modaluseredit"
                @ok="largeModal = false"
              >
                <b-tabs>
                  <b-tab title="Datos Generales">
                    <b-row>
                      <div class="col-sm-4 form-group">
                        <label>Nombre de Usuario</label>
                        <input type="text" v-model="edituser.username" class="form-control" />
                      </div>
                      <div class="col-sm-4 form-group">
                        <label>Rol</label>
                        <select class="custom-select mr-sm-2" v-model="edituser.perfil.rolUsuario">
                          <template v-for="item in roleusers">
                            <option :value="item.value">{{item.text}}</option>
                          </template>
                        </select>
                      </div>
                      <div class="col-sm-4 form-group">
                        <label>Tienda</label>
                        <select
                          class="custom-select mr-sm-2"
                          v-model="edituser.perfil.idEstablecimiento"
                        >
                          <template v-for="item in stores">
                            <option :value="item.idEstablecimiento">{{item.nombreEstablecimiento}}</option>
                          </template>
                        </select>
                      </div>
                    </b-row>
                    <b-row>
                      <div class="col-sm-6 form-group">
                        <label>Apellido Paterno</label>
                        <input
                          type="text"
                          v-model="edituser.perfil.appUsuario"
                          class="form-control"
                        />
                      </div>
                      <div class="col-sm-6 form-group">
                        <label>Apellido Materno</label>
                        <input
                          type="text"
                          v-model="edituser.perfil.apmUsuario"
                          class="form-control"
                        />
                      </div>
                    </b-row>
                    <b-row>
                      <b-col>
                        <div class="form-group">
                          <label>Nombres</label>
                          <input
                            type="text"
                            v-model="edituser.perfil.nomUsuario"
                            class="form-control"
                          />
                        </div>
                      </b-col>
                      <b-col>
                        <div class="form-group">
                          <label>Correo</label>
                          <input
                            type="text"
                            v-model="edituser.perfil.emailUsuario"
                            class="form-control"
                          />
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Asignar Series - Emisión" v-if="validarRol()" >
                    <template v-if="loadingseries">
                      <b-row>
                        <b-col class="text-center">
                          <h5 class="display-5">
                            <i class="fa fa-spin fa-spinner"></i> Cargando Series
                          </h5>
                        </b-col>
                      </b-row>
                    </template>
                    <template v-else>
                      <div class="row">
                        <b-col>
                          <b-form-group label="Facturas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[1]">
                              <template v-for="elem in seriesall[1]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Boletas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[2]">
                              <template v-for="elem in seriesall[2]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.C. Facturas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[3]">
                              <template v-for="elem in seriesall[3]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.C. Boletas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[4]">
                              <template v-for="elem in seriesall[4]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.D. Facturas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[5]">
                              <template v-for="elem in seriesall[5]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.D. Boletas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[6]">
                              <template v-for="elem in seriesall[6]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Guías de R.">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[7]">
                              <template v-for="elem in seriesall[7]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>                       
                      </div>
                      <div class="row">
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Guías de C.">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[10]">
                              <template v-for="elem in seriesall[10]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Proformas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[8]">
                              <template v-for="elem in seriesall[8]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Orden C">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[9]">
                              <template v-for="elem in seriesall[9]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Orden P">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[11]">
                              <template v-for="elem in seriesall[11]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Nota Venta">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[12]">
                              <template v-for="elem in seriesall[12]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Guia Transp.">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[13]">
                              <template v-for="elem in seriesall[13]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Ticket Suministro">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesemUsuario[14]">
                              <template v-for="elem in seriesall[14]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                      </div>
                    </template>
                  </b-tab>
                  <b-tab title="Asignar Series - Consulta" v-if="validarRol()">
                    <template v-if="loadingseries">
                      <b-row>
                        <b-col class="text-center">
                          <h5 class="display-5">
                            <i class="fa fa-spin fa-spinner"></i> Cargando Series
                          </h5>
                        </b-col>
                      </b-row>
                    </template>
                    <template v-else>
                      <div class="row">
                        <b-col>
                          <b-form-group label="Facturas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[1]">
                              <template v-for="elem in seriesall[1]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Boletas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[2]">
                              <template v-for="elem in seriesall[2]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.C. Facturas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[3]">
                              <template v-for="elem in seriesall[3]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.C. Boletas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[4]">
                              <template v-for="elem in seriesall[4]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.D. Facturas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[5]">
                              <template v-for="elem in seriesall[5]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="N.D. Boletas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[6]">
                              <template v-for="elem in seriesall[6]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Guías de R.">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[7]">
                              <template v-for="elem in seriesall[7]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                      </div>
                      <div class="row">
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Guía de C.">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[10]">
                              <template v-for="elem in seriesall[10]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Proformas">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[8]">
                              <template v-for="elem in seriesall[8]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Orden C">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[9]">
                              <template v-for="elem in seriesall[9]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Orden P">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[11]">
                              <template v-for="elem in seriesall[11]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Nota Venta">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[12]">
                              <template v-for="elem in seriesall[12]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Guia Transp.">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[13]">
                              <template v-for="elem in seriesall[13]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="2">
                          <b-form-group label="Ticket Suministro">
                            <b-form-checkbox-group v-model="edituser.perfil.seriesconUsuario[14]">
                              <template v-for="elem in seriesall[14]">
                                <b-form-checkbox
                                  :value="elem.idSerie"
                                  :key="elem.key"
                                >{{elem.nombreSerie}}</b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                      </div>
                    </template>
                  </b-tab>
                </b-tabs>
                <template slot="modal-footer">
                  <template v-if="loadinguser2">
                    <b-button type="button" variant="secondary" class="mr-1 disabled">
                      <i class="fa fa-spin fa-spinner"></i> Grabando
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button
                      type="button"
                      variant="secondary"
                      class="mr-1 disabled"
                      @click="modaluseredit=false"
                    >
                      <i class="fa fa-times"></i> Cerrar
                    </b-button>
                    <b-button type="button" :disabled="validaseries()" variant="primary" @click="updateUser()" class="mr-1">
                      <i class="fa fa-save"></i> Grabar
                    </b-button>
                  </template>
                </template>
              </b-modal>
            </template>
            <template slot="footer">
              <div class="animated fadeIn">
                <b-button
                  type="button"
                  size="sm"
                  variant="primary"
                  @click="abrirModal()"
                  class="mr-1"
                >
                  <i class="fa fa-plus"></i> Agregar
                </b-button>
              </div>
            </template>
          </b-card>

          <!-- fin lista de usuarios -->
        </b-container>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-5 variant="secondary">
          <h5>
            <i class="far fa-address-book"></i> Actualizar datos de Receptor
          </h5>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <b-container class="mt-4 mb-4" fluid>
          <!-- direcc clientes -->
          <b-card>
            <template slot="header">
              <i class="fa fa-edit"></i> Actualizar Direccion de clientes
            </template>
            <template>
              <b-form-row>
                <b-col>
                  <b-form-group>
                    <div class="pb-2">
                    Ingrese el <b>RUC</b> o <b>DNI</b> a actualizar...  en el caso de RUC 10 est&aacute; prohibido mostrar la direcci&oacute;n de acuerdo a <b>Ley 29733</b> de protecci&oacute;n de datos.
                    </div>
                    <b-row align-v="center">
                      <b-col cols="12">
                        <template>
                          <b-form-input v-model="documentoUser" placeholder="RUC o DNI (*)"></b-form-input>
                        </template>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row align-v="center" v-if="razon_social != ''">
                      <b-col cols="12">
                        <template>
                          <b-form-input v-model="razon_social" placeholder="Razon Social" disabled></b-form-input>
                        </template>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row align-v="center" v-if="domicilio_fiscal != ''">
                      <b-col cols="12">
                        <template>
                          <b-form-input
                            v-model="domicilio_fiscal"
                            placeholder="Domicilio Fiscal"
                            disabled
                          ></b-form-input>
                        </template>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </template>
            <template slot="footer">
              <div class="animated fadeIn">
                <template>
                  <b-button
                    size="sm"
                    v-if="!updateClienteDatos"
                    type="button"
                    variant="primary"
                    @click="updateClient"
                  >
                    <i class="fa fa-plus"></i> Actualizar
                  </b-button>
                  <b-button size="sm" v-else type="button" variant="secondary">
                    <i class="fa fa-spin fa-spinner"></i> Actualizando...
                  </b-button>
                </template>
              </div>
            </template>
          </b-card>
          <!-- fin direcc clientes -->
        </b-container>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button :disabled="user.rol!='Admin' && user.rol!='Usuario'" block href="#" v-b-toggle.accordion-6 variant="secondary">
          <h5>
            <i class="fas fa-print"></i> Opciones de Impresión y Código
          </h5>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
        <b-container class="mt-4 mb-4" fluid>
          <b-card-group deck>
            <!-- impresion -->
            <b-card>
              <template slot="header">
                <div class="display-5">
                  <i class="fa fa-print"></i> Opciones de Impresión
                </div>
              </template>
              <template v-if="!cargarconfigdoc">
                <b-form-group label="MEDIDA">
                  <b-input-group>
                    <b-form-select v-model="size" :options="sizes" />
                    <b-input-group-append>
                      <b-btn variant="secondary">
                        <i class="fa fa-file-text-o"></i>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <template v-if="Boolean(size == 'Custom')">
                  <b-form-group label="ALTO">
                    <b-input-group append="mm">
                      <b-form-input
                        type="number"
                        v-model="witdh"
                        :disabled="!Boolean(size == 'Custom')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group label="ANCHO">
                    <b-input-group append="mm">
                      <b-form-input
                        type="number"
                        v-model="height"
                        :disabled="!Boolean(size == 'Custom')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </template>
                <b-form-group label="ORIENTACIÓN">
                  <b-input-group>
                    <b-form-select v-model="orientation" :options="orientations" />
                    <b-input-group-append>
                      <b-btn variant="secondary">
                        <i class="fa fa-rotate-left"></i>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </template>
              <template v-else>
                <b-row>
                  <b-col>
                    <h5 class="display-5 text-center">
                      <i class="fa fa-spin fa-spinner"></i> Cargando datos
                    </h5>
                  </b-col>
                </b-row>
              </template>
              <template slot="footer">
                <template v-if="!cargarconfigdoc2">
                  <b-button size="sm" variant="secondary" class="mr-3">
                    <i class="fa fa-times"></i> Cancelar
                  </b-button>
                  <b-button size="sm" variant="primary" @click="setConfigdoc()">
                    <i class="fa fa-save"></i> Grabar
                  </b-button>
                </template>
                <template v-else>
                  <b-button size="sm" variant="secondary" disabled>
                    <i class="fa fa-spin fa-spinner"></i> Grabando
                  </b-button>
                </template>
              </template>
            </b-card>
            <!-- fin impresion -->

            <!-- Impresion personalizada -->
            <b-card>
              <template slot="header">
                <div class="display-5">
                  <i class="fa fa-code"></i> Opciones de impresion personalizada PDV
                </div>
              </template>
              <template>
                <h6>Seleccione una Sucursal</h6>
                 <b-row>
                   <b-col>
                      <select class="custom-select mr-sm-2" v-model="selectedInfoUsuario" >
                          <template v-for="(usuario, index) in listaUsuarioInfo">
                            <option :value="index" :key="index" >{{usuario.nombreInformacion}}</option>
                          </template>      
                      </select>
                   </b-col>
                 </b-row>
                <br>
                <h6>Ingrese estos campos para personalizar su plantilla</h6>
                <b-row>
                  <b-col>
                    <div class="form-label-group">
                      <b-form-input
                        size="xs"
                        type="text"
                        class="form-control address"
                        v-model="nombreSucursal"
                        placeholder="Ingrese Nombre Sucursal"
                      ></b-form-input>
                      <label>Ingrese Nombre Sucursal</label>
                    </div>
                  </b-col>
                </b-row>
                <br>
                <b-row>
                  <b-col>
                    <div class="form-label-group">
                      <b-form-input
                        size="xs"
                        type="text"
                        class="form-control address"
                        v-model="nombreComercial"
                        placeholder="Ingrese Nombre Comercial"
                      ></b-form-input>
                      <label>Ingrese Nombre Comercial</label>
                    </div>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col>
                    <div class="form-label-group">
                      <b-form-input
                        size="xs"
                        type="text"
                        class="form-control address"
                        v-model="direccion"
                        placeholder="Ingrese Dirección"
                      ></b-form-input>
                      <label>Ingrese Dirección</label>
                    </div>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col>
                    <div class="form-label-group">
                      <b-form-input
                        size="xs"
                        type="text"
                        class="form-control address"
                        v-model="telefono"
                        placeholder="Ingrese Telefono"
                      ></b-form-input>
                      <label>Ingrese Telefono</label>
                    </div>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col>
                    <div class="form-label-group">
                      <b-form-input
                        size="xs"
                        type="text"
                        class="form-control address"
                        v-model="paginaWeb"
                        placeholder="Ingrese Página Web"
                      ></b-form-input>
                      <label>Ingrese Página Web</label>
                    </div>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col>
                    <div class="form-label-group">
                      <b-form-input
                        size="xs"
                        type="text"
                        class="form-control address"
                        v-model="correo"
                        placeholder="Ingrese Correo Válido"
                      ></b-form-input>
                      <label>Ingrese Correo Válido</label>
                    </div>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col>
                    <div class="form-label-group">
                      <b-form-input
                        size="xs"
                        type="text"
                        class="form-control address"
                        v-model="textoPersonalizado1"
                        placeholder="Ingrese Texto Persoalizado 1"
                      ></b-form-input>
                      <label>Ingrese Texto Persoalizado 1</label>
                    </div>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col>
                    <div class="form-label-group">
                      <b-form-input
                        size="xs"
                        type="text"
                        class="form-control address"
                        v-model="textoPersonalizado2"
                        placeholder="Ingrese Texto Persoalizado 21"
                      ></b-form-input>
                      <label>Ingrese Texto Persoalizado 2</label>
                    </div>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col xl="3">
                    <b-form-checkbox switch v-model="checked" name="check-button">Logo</b-form-checkbox>
                  </b-col>
                  <b-col xl="4" v-if="checked">
                    <b-row>
                      <b-col xl="5">Alto:</b-col>
                      <b-col xl="7">
                        <b-form-input v-model="alto" size="sm"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col xl="4" v-if="checked">
                    <b-row>
                      <b-col xl="5">Ancho:</b-col>
                      <b-col xl="7">
                        <b-form-input v-model="ancho" size="sm"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
              <template slot="footer">
                <template>
                    <template v-if="verActualizar">
                      <b-button size="sm" :disabled="validarlogo()" variant="success" class="ml-3" @click="actualizarUser()">Grabar</b-button>  
                    </template>
                    <template v-else>
                      <b-button :disabled="validarInfo()" size="sm" variant="success" @click="setDataImpresion()">
                        <i class="fa fa-save"></i> Grabar Nuevo
                      </b-button> 
                    </template>            
                  </template>
                <template>
                  <b-button style="float:right" @click="verGrabarNuevo()"  variant="warning"><i class="fas fa-plus-circle"></i> Crear nueva sucursal</b-button>
                </template>
              </template>
            </b-card>

            <!-- Fin de impresion personalizada -->

            <!-- codigo -->
            <b-card>
              <template slot="header">
                <div class="display-5">
                  <i class="fa fa-code"></i> Opciones de Código
                </div>
              </template>
              <template v-if="!cargarconfigcode">
                <b-form-group label="TIPO">
                  <b-form-checkbox-group v-model="typecode">
                    <b-form-checkbox v-b-tooltip.hover title="PDF417" value="PDF417">
                      <i class="fa fa-barcode fa-2x"></i>
                    </b-form-checkbox>
                    <b-form-checkbox v-b-tooltip.hover title="QR" value="QR">
                      <i class="fa fa-qrcode fa-2x"></i>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </template>
              <template v-else>
                <b-row>
                  <b-col>
                    <h5 class="display-5 text-center">
                      <i class="fa fa-spin fa-spinner"></i> Cargando datos
                    </h5>
                  </b-col>
                </b-row>
              </template>
              <template slot="footer">
                <template v-if="!cargarconfigcode2">
                  <b-button size="sm" variant="secondary" class="mr-3">
                    <i class="fa fa-times"></i> Cancelar
                  </b-button>
                  <b-button size="sm" variant="primary" @click="setConfigcode()">
                    <i class="fa fa-save"></i> Grabar
                  </b-button>
                </template>
                <template v-else>
                  <b-button size="sm" variant="secondary" disabled>
                    <i class="fa fa-spin fa-spinner"></i> Grabando
                  </b-button>
                </template>
              </template>
            </b-card>

            <!-- fin codigo -->
          </b-card-group>
        </b-container>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-7 variant="secondary">
          <h5>
            <i class="fas fa-print"></i> TAG
          </h5>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
        <b-container class="mt-4 mb-4" fluid>
          <tag></tag>
        </b-container>
      </b-collapse>
    </b-card>

    <!-- Opciones de emision personalizada -->
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-8 variant="secondary">
          <h5>
            <i class="fas fa-business-time"></i> Informaci&oacute;n Corporativa
          </h5>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
        <b-row>
          <b-col cols="6">
                <!-- Personalizacion de Factura -->
                <!-- <div class="emisionPersonalizada"> -->
                      <b-card class="mt-4 mb-4 ml-4" >
                        <template slot="header" style="background-color:#D5E6FA">
                          <div class="display-5">
                            <i class="fa fa-print"></i> Descargas
                          </div>
                        </template>
                        <ul>
                          <li>Ejemplo de Excel para levantar la base de datos de Productos: <b-badge href="http://telemovildata.com/producto/ejemp_base-datos_excel21.xlsx" variant="primary">Aqu&iacute;</b-badge></li>
                          <li>Ejemplo de Excel para Carga Masiva de Items: <b-badge  href="http://telemovildata.com/producto/ModeloExcelCargaMasivadeItems.xlsx" variant="primary">Aqu&iacute;</b-badge></li>
                          <li>Ejemplo de Excel para Carga Masiva de Guias de Remisión: <b-badge  href="http://telemovildata.com/producto/ejemp_base-datos_carga_masiva_guias.xlsx" variant="primary">Aqu&iacute;</b-badge></li>
                          <li>Ejemplo de Excel para Carga Masiva de Guias Relacionadas: <b-badge  href="http://telemovildata.com/producto/ejemplo_excel_guias_relacionadas.xlsx" variant="primary">Aqu&iacute;</b-badge></li>
                        </ul>
                      </b-card>
                <!-- </div> -->
          </b-col>
          <b-col>
              <b-card class="mt-4 mb-4 mr-4"  >
                <template slot="header" >
                  <div class="display-5" >
                  <i class="fa fa-print"></i> Sistema Contable Quipu
                  </div>
                </template>
                  <div v-if="servicio">
                      <ul>
                          <li>Descargar Sistema Telemovil contable: <b-button style="background-color:#D5E6FA; color:#13549F;border-color:#D5E6FA"  href="https://quiputelemovil.s3.amazonaws.com/InstaladorQuipuTelemovil.zip">Descargar</b-button></li>
                      </ul>
                  </div>
                  <div v-else>
                      <ul>
                          <li>Descargar Sistema Telemovil contable <b-button @click="modalService" variant="primary" style="background-color:#D5E6FA; color:#13549F;border-color:#D5E6FA">Descargar</b-button></li>
                      </ul>
                  </div>
                </b-card>
                <b-modal v-model="modalServicio" size="lg">
                  <template #modal-title>
                    <b-row>
                      <b-col cols="12">
                        <div style="width:725%">
                         <div>
                            <b-alert show class="estilo"><h3>Hola !</h3></b-alert>
                         </div>
                        </div>
                      </b-col>
                    </b-row>
                    <!-- <h3>Hola !</h3> -->
                  </template>
                  <div>
                    <b-card no-body class="overflow-hidden " style="max-width: 840px;">
                      <b-row no-gutters>
                        <b-col md="6">
                          <b-card-img src="https://www.omniumdigital.com/wp-content/uploads/2017/06/gestion-empresarial.jpg" alt="Image" class="rounded-0"></b-card-img>
                        </b-col>
                        <b-col md="6">
                          <b-card-body title="Por el momento no cuenta con el Servicio">
                            <b-card-text>
                              Solicite mayor informaci&oacute;n del servicio comunic&aacute;ndose al n&uacute;mero <b>998 155 409</b>
                              <br>
                              <hr>
                              O enviando un correo solicitando informacion del servicio <b-button style="background-color:#D5E6FA; color:#13549F;border-color:#D5E6FA">Enviar email</b-button>
                            </b-card-text>
                          </b-card-body>
                        </b-col>
                      </b-row>
                    </b-card>
                  </div>
                  <template slot="modal-footer">
                    <b-button @click="cerrarServicio" style="background-color:#D5E6FA; color:#13549F;border-color:#D5E6FA">Cerrar</b-button>
                  </template>
                </b-modal>
          </b-col>
        </b-row>
        <!-- contador -->
        <b-row>
          <b-col cols="6">
              <b-card class="mt-4 mb-4 ml-4 ">
                <template slot="header" style="background-color:#D5E6FA">
                    <div class="display-5">
                       <i class="fas fa-address-card"></i> Autorizar Contador
                    </div>
                  </template>
                  <b-row>
                    <b-col cols="12" sm="4" md="4" lg="4" class="mt-2">
                      <ul>
                        <li>Autorizar Contador con el Sistema Telemovil Contable:</li>
                      </ul>
                    </b-col>
                    <b-col cols="12" sm="4" md="4" lg="4">
                      <div class="form-label-group">
                        <b-form-input v-model="autorizar" @keyup.enter="autorizarContador()" type="text" placeholder="Atencion a"  maxlength="11" class="form-control address"></b-form-input>
                        <label>RUC Contador</label>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="4" md="4"	lg="3">
                      <b-button variant="primary"  @click="autorizarContador()" :disabled="autorizar.length<11">Autorizar</b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mt-2">
                      <template v-if="cargando">
                        <h5>
                          Cargando
                          <i class="fa fa-spin fa-spinner"></i>
                        </h5>
                      </template>
                      <template v-else>
                        <b-table
                          :tbody-tr-class="rowClass"
                          head-variant="light"
                          outlined
                          small
                          :items="listadoInvertido" 
                          :fields="listaAsociadosTerminados_fields">
                          <template slot="estado" slot-scope="row">
                            <template v-if="row.item.estado == '2'">                           
                               <b-badge variant="danger">Terminado</b-badge>
                            </template>
                            <template v-else>
                                <b-badge variant="success">Activo</b-badge>
                            </template>
                          </template>
                        </b-table>
                      </template>   
                    </b-col>
                </b-row>
              </b-card>
          </b-col>
          <b-col></b-col>
        </b-row>
        <!-- fin contador -->
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-9 variant="secondary">
          <h5>
            <b-img style="width:2%; height:10% " src="images/sunat.png"/> Credenciales SUNAT
          </h5>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
        <b-container class="mt-4 mb-4" fluid>
          <b-card style="width:50%; margin-left:24%">
            <template slot="header">
              <i class="fa fa-key"></i> Crendenciales SUNAT
            </template>
            <b-row>
              <b-col cols="3">
               Usuario SOL Secundario:
              </b-col>
              <b-col>
                <b-input maxlength="8" autocomplete="off" id="passwordSol1"  placeholder="Usuario SOL" v-model="usuarioSol" :disabled="activarInfo"></b-input>
              </b-col>
              <b-col cols="1">
                <b-button 
                  variant="ligth"
                  v-b-tooltip.hover.topright="'USUARIO DE 8 CARACTERES'">
                  <i class="fa fa-exclamation-circle fa-lg" aria-hidden="true"></i>
                </b-button>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col cols="3">
                Clave SOL Secuandario:<b-checkbox v-model="verclaveSol"></b-checkbox>
              </b-col>
              <b-col>
                <b-input autocomplete="new-password" id="passwordSol" type="password" placeholder="Clave SOL" v-model="claveSol" :disabled="activarInfo"></b-input>
              </b-col>
              <b-col cols="1">
                <b-button 
                  variant="ligth"
                  v-b-tooltip.hover.topright="'CLAVE SOL MINIMO 6 CARACTERES'">
                  <i class="fa fa-exclamation-circle fa-lg" aria-hidden="true"></i>
                </b-button>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col cols="3">
                client_id:
              </b-col>
              <b-col>
                <b-input autocomplete="off" id="passwordSol2" v-model="clientId" :disabled="activarInfo"></b-input>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col cols="3">
                client_secret:
              </b-col>
              <b-col>
                <b-input autocomplete="off" id="passwordSol3" v-model="clientSecret" :disabled="activarInfo"></b-input>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col cols="5"><template v-if="activarInfo"><div style="color:red">USTED CUENTA CON INFORMACION REGISTRADA</div></template></b-col>
              <b-col cols="2">
                <b-button v-if="activarInfo" variant="danger" @click="activarDatos()">Editar</b-button>
                <b-button v-else variant="primary" :disabled="validarCamposSunat()" @click="credencialesSunat()">Enviar</b-button>
                
              </b-col>
              <b-col cols="5"><div class="opUrl" @click="urlOpen()">PASOS PARA LA CREACION</div></b-col>
            </b-row>
          </b-card>
        </b-container>
      </b-collapse>
    </b-card>
    <vue-snotify></vue-snotify>
  </div>
</template>
<script>
import axios from "axios";
import { TipoMoneda } from "@/shared/utils";
import Tag from "@/components/userpanel/tag";
import { Departamentos } from '@/shared/utils';
import { entidadEmisora } from "@/shared/utils";
export default {
  name: "tabs",
  components: { Tag },
  data() {
    return {
      cargando:true,
      checked: false,
      ancho: "",
      alto: "",
      cargarimpresion: false,
      responseinfoclient: "",
      telefono: "",
      nombreComercial: "",
      nombreSucursal: "",
      direccion: "",
      paginaWeb: "",
      correo: "",
      textoPersonalizado1: "",
      textoPersonalizado2: "",
      emitiendobank: true,
      actualizandobank: true,
      changeNumeroCuenta: 0,
      changeCci: 0,
      actualizar: false,
      validbancoguardar: true,
      otrobanco: "",
      addbank: false,
      isBusy: false,
      listaBancos: [],
      buscandoCtaDetraccion: false,
      detraccionExiste: false,
      botonesDetraccionExiste: false,
      previoModificar: false,
      vistaModificar: false,
      modificando: false,
      crearCuentaDetraccion: false,
      agregandoCuentaDet: false,
      razon_social: "",
      domicilio_fiscal: "",
      documentoUser: "",
      updateAccount: false,
      modifyAccount: false,
      modifyAccountDatos: false,
      updateClienteDatos: false,
      cuentaDetracionAdmin: "",
      addDetraccion: true,
      cuentaDetraccion: "",
      tabIndex: [0, 0],
      tabs: ["Usuario", "Contraseña", "Gestion"],
      stores: [],
      banco_fields: [
        { key: "banco", label: "Banco", sortable: true },
        { key: "tipoCuenta", label: "Tipo Cta.", sortable: true },
        { key: "moneda", label: "Moneda", sortable: true },
        { key: "numeroCuenta", label: "Cuenta", sortable: true },
        { key: "cci", label: "CCI", sortable: true },
        { key: "acciones", label: "Acciones", sortable: true }
      ],
      storeitems: [
        { key: "index", label: "#", sortable: true },
        { key: "nombreEstablecimiento", label: "Nombre", sortable: true },
        { key: "codigoEstablecimiento", label: "Código", sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "ubigeo", label: "Ubigeo", sortable: true },
        { key: "direccion", label: "Direccion", sortable: true },
        { key: "acciones", label: "Acciones", sortable: true }
      ],
      banco: {
        id: 0,
        descripcion: "BCP"
      },
      Bancos: [
        { id: 0, descripcion: "BCP" },
        { id: 1, descripcion: "BBVA" },
        { id: 2, descripcion: "Interbank" },
        { id: 3, descripcion: "Scotiabank Perú" },
        { id: 4, descripcion: "PICHINCHA" },
        { id: 5, descripcion: "MiBanco" },
        { id: 6, descripcion: "BanBif" },
        { id: 7, descripcion: "Banco de Comercio" },
        { id: 8, descripcion: "Banco Pichincha" },
        { id: 9, descripcion: "Citibank Perú" },
        { id: 10, descripcion: "Banco GNB Perú" },
        { id: 11, descripcion: "Banco Falabella" },
        { id: 12, descripcion: "Banco de la Nación" },
        { id: 13, descripcion: "INGRESE NUEVO BANCO" }
      ],
      Cuentas: [
        { id: 0, descripcion: "CTA. CTE." },
        { id: 1, descripcion: "CTA. AHORROS" },
        { id: 2, descripcion: "CTA. MAESTRA" },
        { id: 3, descripcion: "T. CRÉDITO" },
        { id: 4, descripcion: "CTA. DETRACCIONES" },
        { id: 5, descripcion: "INGRESE OTRA CUENTA" }
      ],
      tipodemoneda: {
        id: "1",
        codigo: "PEN",
        descripcion: "SOLES",
        simbolo: "S/."
      },
      idBanco: "",
      tipoMoneda: TipoMoneda,
      numerocuenta: "",
      cci: "",
      cuenta: { id: 0, descripcion: "CTA. CTE." },
      otracuenta: "",
      loadingstores: false,
      namestore: "",
      codestore: "",
      loadingstores2: false,
      editidstore: "",
      editnamestore: "",
      editcodestore: "",
      loadingstores3: false,
      users: [],
      useritems: [
        { key: "index", label: "#", sortable: true },
        { key: "username", label: "Nombre", sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "rol", label: "Rol", sortable: true },
        { key: "acciones", label: "Acciones", sortable: true }
      ],
      roleusers: [
        { value: 1, text: "Administrador" },
        { value: 2, text: "Operador" },
        { value: 3, text: "Consultor" },
        { value: 4, text: "Caja" }
      ],
      roleusers2: [
        { value: 1, text: "Administrador" },
        { value: 2, text: "Operador" },
        { value: 3, text: "Consultor" },
        { value: 4, text: "Asistente Contable"}
      ],
      loadingseries: false,
      userseriesf: [],
      userseriesb: [],
      userseriesncf: [],
      userseriesncb: [],
      userseriesndf: [],
      userseriesndb: [],
      userseriesgr: [],
      seriesfacturas: [],
      seriesboletas: [],
      seriesnotascf: [],
      seriesnotascb: [],
      seriesnotasdf: [],
      seriesnotasdb: [],
      seriesgr: [],
      seriesgc: [],
      seriesp: [],
      seriesoc: [],
      seriesop: [],
      seriesnv: [],
      seriesgt: [],
      seriests: [],
      seriesfacturasc: [],
      seriesboletasc: [],
      seriesnotascfc: [],
      seriesnotascbc: [],
      seriesnotasdfc: [],
      seriesnotasdbc: [],
      seriesgrc: [],
      show: true,
      personalizar: {
        claveNueva1: "",
        claveNueva2: ""
      },
      modalstore: false,
      modalupdate: false,
      modaluser: false,
      modaluseredit: false,
      user: {
        username: "",
        rol: "",
        idEmisor: "",
        cuenta: {
          razonSocial: ""
        },
        perfil: {}
      },
      tabs: 0,
      passvalid: false,
      loading: false,
      change: false,
      loadingusers: false,
      loadinguser: false,
      loadinguser2: false,
      // series: [],
      soptions: [
        { value: 5, text: 5 },
        { value: 15, text: 15 },
        { value: 25, text: 25 },
        { value: 50, text: 50 },
        { value: 100, text: 100 }
      ],
      sperPage: 15,
      scurrentPage: 1,
      srows: 0,
      uoptions: [
        { value: 5, text: 5 },
        { value: 15, text: 15 },
        { value: 25, text: 25 },
        { value: 50, text: 50 },
        { value: 100, text: 100 }
      ],
      uperPage: 15,
      ucurrentPage: 1,
      urows: 0,
      newuser: {
        username: "",
        perfil: {
          rol: "",
          idEstablecimiento: 0,
          appUsuario: "",
          apmUsuario: "",
          nomUsuario: "",
          rolUsuario: "",
          seriesemUsuario: {
            "1": [],
            "2": [],
            "3": [],
            "4": [],
            "5": [],
            "6": [],
            "7": [],
            "8": [],
            "9": [],
            "10": [],
            "11": [],
            "12": [],
            "13": [],
            "14": []
          }
        }
      },
      edituser: {
        username: "",
        perfil: {
          rol: "",
          idEstablecimiento: 0,
          appUsuario: "",
          apmUsuario: "",
          nomUsuario: "",
          rolUsuario: "",
          seriesemUsuario: {
            "1": [],
            "2": [],
            "3": [],
            "4": [],
            "5": [],
            "6": [],
            "7": [],
            "8": [],
            "9": [],
            "10": [],
            "11": [],
            "12": [],
            "13": [],
            "14": []
          },
          seriesconUsuario: {
            "1": [],
            "2": [],
            "3": [],
            "4": [],
            "5": [],
            "6": [],
            "7": [],
            "8": [],
            "9": [],
            "10": [],
            "11": [],
            "12": [],
            "13": [],
            "14": []
          }
        }
      },
      //sett
      totalRows: null,
      cargarconfigdoc: false,
      cargarconfigcode: false,
      cargarconfigacc: false,
      cargarconfigadd: false,
      cargarconfigserie: false,
      cargarconfigdoc2: false,
      cargarconfigcode2: false,
      cargarconfigacc2: false,
      cargarconfigadd2: false,
      cargarconfigserie2: false,
      cargarconfigserie3: false,
      sizes: [
        { value: "A3", text: "A3" },
        { value: "A4", text: "A4" },
        { value: "A5", text: "A5" },
        { value: "Letter", text: "CARTA" },
        { value: "Legal", text: "OFICIO" },
        { value: "Tabloid", text: "TABLOIDE" },
        { value: "Custom", text: "PERSONALIZADO" }
      ],
      size: "Custom",
      height: "80",
      witdh: "240",
      orientations: [
        { value: "portrait", text: "VERTICAL" },
        { value: "landscape", text: "HORIZONTAL" }
      ],
      orientation: "portrait",
      typecode: "QR",
      user: {
        username: "",
        rol: "",
        idEmisor: "",
        cuenta: {
          razonSocial: "",
          direccion: {}
        }
      },
      logo: "",
      changelogo: false,
      savinglogo: false,
      urlimg: null,
      modalserie: false,
      modalserieupdate: false,
      modalseriedelete: false,
      comprobants: [
        { value: 1, name: "Factura" },
        { value: 2, name: "Boleta de Venta" },
        { value: 3, name: "Nota de Crédito - Factura" },
        { value: 4, name: "Nota de Crédito - Boleta" },
        { value: 5, name: "Nota de Débito - Factura" },
        { value: 6, name: "Nota de Débito - Boleta" },
        { value: 7, name: "Guía de Remisión" },
        { value: 10, name: "Guía de Control" },
        { value: 8, name: "Proforma" },
        { value: 9, name: "Orden de Compra" },
        { value: 11, name: "Orden de Pago" },
        { value: 12, name: "Nota de Venta" },
        { value: 13, name: "Guía Transportista" },
        { value: 14, name: "Ticket Suministro" }
      ],
      tabIndex: 0,
      typecomprobant: 0,
      serie: "",
      startin: 0,
      typecomprobant2: 0,
      typecomprobant3: 0,
      serie2: "",
      serie3: "",
      startin2: 0,
      idserie: "",
      series: {
        type1: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },
          cargar: false
        },
        type2: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },
          cargar: false
        },
        type3: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },
          cargar: false
        },
        type4: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },
          cargar: false
        },
        type5: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },
          cargar: false
        },
        type6: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },
          cargar: false
        },
        type7: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },
          cargar: false
        },
        type8: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },
          cargar: false
        },
        type9: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },
          cargar: false
        },
        type10: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },

          cargar: false
        },
        type11: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },

          cargar: false
        },
        type12: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },

          cargar: false
        },
        type13: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },

          cargar: false
        },
        type14: {
          info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
          },

          cargar: false
        }
      },
      seriesfields: [
        { key: "index", label: "#", sortable: true },
        { key: "nombreSerie", label: "Serie", sortable: true },
        { key: "ultimoSerie", label: "Útimo", sortable: true },
        { key: "acciones", label: "Acciones", sortable: true }
      ],
      seriesall: [],
      currentPage: 1,
      tipo: 1,
      validarServicio:[],
      cod:'wenet',
      servicio: false,
      modalServicio:false,
      listDepartamento: Departamentos,
      departamentoUbigeo:'',
      provOrigen:false,
      provOrigenCargando:false,
      listProvinceOrigen: [],
      provinciaUbigeo:'',
      distOrigen:false,
      distOrigenCargando:false,
      distritoUbigeo:'',
      listDistrictOrigen: [],
      ubigeoPartida:'',
      direcUbigeo:'',
      autorizar:'',
      listaAsociados:[],
      listaAsociados_fields:[
        {key:"idContador", label:"RUC Contador"},
        {key:"fechaAfiliacion", label:"Fecha Afiliado"},
        // {key:"fechaTermino", label:"Fecha Fin"},
        {key:"estado", label:"Estado"}
      ],
      listaAsociadosTerminados:[],
      listaAsociadosTerminados_fields:[
        {key:"idContador", label:"RUC Contador"},
        {key:"fechaAfiliacion", label:"Fecha Afiliado"},
        {key:"fechaTermino", label:"Fecha Fin"},
        {key:"estado", label:"Estado"}
      ],
      servicioConta:false,
      listadoInvertido:[],
      listaUsuarioInfo:[],
      selectedInfoUsuario:null,
      idmovil:'',
      verActualizar:true,
      visible:false,
      longitud:false,
      mayus:false,
      minus:false,
      number:false,
      mostrarSerie:false,
      mostrarSerieValor:'',
      selectedIGV:18,
      optionsIGV:[
        {value:18,text:'18'},
        {value:10.5,text:'10.5'}
      ],
      validarSerie:true,
      usuarioSol:null,
      claveSol:null,
      clientId:null,
      clientSecret:null,
      verclaveSol:false,
      activarInfo:false,
      autorizacionTransporte:'',
      mostrarMtc:true,
      mostrarCodigoMtc:'',
      mostrarOcultarGuia:'',
      indexEntidadEmisora:0,
      infoEntidadEmisora:entidadEmisora,
      nroAutorizacionTrasporte:'',
      autorizacionTransporteInfo:{},
      cargandoIgv: false,
      amazonia: null
    };
  },
  watch: {
    modaluseredit(){
      if(this.modaluseredit == false){
        let vacio = []
        this.$store.commit('setemailpanel', vacio)
      }
    },
    numerocuenta: function() {
      if (this.numerocuenta == "") {
        this.validbancoguardar = true;
      } else if (this.numerocuenta != "") {
        this.validbancoguardar = false;
      }
    },
    tabIndex: function() {
      this.getSeriesbyType(this.tabIndex + 1);
    },
    departamentoUbigeo(){
      this.provOrigen = true;
      this.searchProvinceOrigen();
    },
    provinciaUbigeo(){
      this.distOrigen = true,
      this.distOrigenCargando = true,
      this.searchDistrictOrigen(this.distOrigenCargando)
    },
    distritoUbigeo() {
      this.distOrigenCargando = false,
      this.ubigeoPartida = this.departamentoUbigeo + this.provinciaUbigeo + this.distritoUbigeo.codDistrito
      // this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre,
      // this.modalUbigeoPartida = false

    },
    selectedInfoUsuario(){
      this.idmovil = this.listaUsuarioInfo[this.selectedInfoUsuario].idInformacionmovil
      this.verActualizar = true;
      this.actualizarMostrar()
    },
    mostrarSerie(){
      if(this.mostrarSerie){
        this.mostrarSerieValor = 2
      }else if(!this.mostrarSerie){
         this.mostrarSerieValor = 3
      }
    },
    serie(){
      if(this.serie.length == 3 && this.startin >= 0 ){
            this.validarSerie = false;
        }else{
          this.validarSerie = true;
      }
    },
   startin(){
     if(this.startin >= 0 && this.serie.length == 3 ){
        this.validarSerie = false;
      }else{
        this.validarSerie = true;
      }
   },
   verclaveSol(){
      let tipo = document.getElementById("passwordSol");
      if(tipo.type == "password"){
          tipo.type = "text";
      }else{
          tipo.type = "password";
      }
    },
  },
  mounted() {
    this.amazonia = this.$store.state.user.data.amazonia
    this.autorizacionTransportista();
    this.infoSunat();
    this.userData(),
      this.getStores(),
      this.getUsers(),
      this.getSeries(),
      this.getSeriesDoc(),
      this.listBanks(),
      this.showAccountDetraction(),
      this.getSeriesbyType(1),
      this.getDataImpresion(),
      this.ServicioRuc();
      this.mostrarAsociados();
      this.listarInfoUsuario()
      this.modalActualizarUsuario()
      this.ocultarGuiaTransportista()
    // this.getSeriesbyType(2),
    // this.getSeriesbyType(3),
    // this.getSeriesbyType(4),
    // this.getSeriesbyType(5),
    // this.getSeriesbyType(6),
    // this.getSeriesbyType(7),
    // this.getSeriesbyType(8),
    // this.getSeriesbyType(9)
  },
  methods: {
    configurarAmazonia(valor) {
      axios.post(process.env.VUE_APP_API_URL + "emisor/configuracion/amazonia", {
      token: this.$store.getters.userToken,
      emiteAmazonia: valor
    })
    .then(response => {
      console.log(response.data)
    })
    .catch(error => {
      console.log(error)
    })
  },
    ocultarGuiaTransportista(){
      this.mostrarOcultarGuia = this.$store.getters.guiaTransportista
    },
    autorizacionTransportista(){
      this.mostrarCodigoMtc = this.$store.getters.guiaTransportista
      
      axios
      .post(process.env.VUE_APP_API_URL + "guiaremitente/guiatransportista/index",{
        token:this.$store.getters.userToken
      })
      .then(response =>(
        this.autorizacionTransporteInfo = response.data.data
      ))
      .catch(error=>(
        console.log('error autorizacion',error)
      ))
    },
    actualizarAutorizacion(){
      if(this.nroAutorizacionTrasporte.length <3){
          this.$snotify.warning("Autorización transportista debe contener de 3 a más caracteres ", "Cuidado!")
      }else if(this.autorizacionTransporte.length <3){
          this.$snotify.warning("Registro MTC debe contener de 3 a más caracteres ", "Cuidado!")
      }else if(this.indexEntidadEmisora == ''){
          this.$snotify.warning("Seleccionar Cod. Entidad Emisora ", "Cuidado!")
      }else{
         axios
        .post(process.env.VUE_APP_API_URL + "guiaremitente/guiatransportista/update",{
          token:this.$store.getters.userToken,
          idEntidad:this.infoEntidadEmisora[this.indexEntidadEmisora].codigo,
          numeroPermiso:this.nroAutorizacionTrasporte,
          autorizacionMtc:this.autorizacionTransporte
        })
        .then(responde=>(
          this.$snotify.success("Código de Autorización actualizado", "Exito"),
          this.autorizacionTransportista(),
          this.mostrarMtc = true
        ))
        .catch(error=>(
          console.log(error)
        ))
      }
    },
    autorizacionMTC(){
      this.mostrarMtc = false;
    },
    setDataImpresion: function() {
      this.cargarimpresion = true;
      axios
        .post(process.env.VUE_APP_API_URL + "movil/informacioncliente", {
          token: this.$store.getters.userToken,
          // idEmisor: '',
          telefono: this.telefono,
          nombrecomercial: this.nombreComercial,
          direccion: this.direccion,
          paginaweb: this.paginaWeb,
          correo: this.correo,
          textopersonalizado1: this.textoPersonalizado1,
          textopersonalizado2: this.textoPersonalizado2,
          estadologo: this.checked,
          nombreInformacion: this.nombreSucursal,
          ancho: parseFloat(this.ancho),
          alto: parseFloat(this.alto)
        })
        .then(
          response => (
            (this.cargarimpresion = false),
            this.$snotify.success(response.data.msg, "Exito"),
            this.listarInfoUsuario()
          )
        )
        .catch(error => (this.cargarimpresion = false));
    },
    getDataImpresion: function() {
      this.cargarimpresion = true;
      axios
        .post(
          process.env.VUE_APP_API_URL + "movil/informacioncliente/mostrar",
          {
            token: this.$store.getters.userToken
          }
        )
        .then(
          response => (
            (this.cargarimpresion = false),
            (this.telefono = response.data.response.telefono),
            (this.nombreComercial = response.data.response.nombreComercial),
            (this.nombreSucursal = response.data.response.nombreInformacion),
            (this.direccion = response.data.response.direccion),
            (this.paginaWeb = response.data.response.paginaWeb),
            (this.correo = response.data.response.correo),
            (this.textoPersonalizado1 = response.data.response.textoPersonalizado1),
            (this.textoPersonalizado2 = response.data.response.textoPersonalizado2),
            this.idmovil = response.data.response.idInformacionmovil,
            this.dataLogo(response.data.response),
              this.listarInfoUsuario()
          )
        )
        .catch(error => (this.cargarimpresion = false));
    },
    dataLogo: function(data) {
      if (data.impLogo == 1) {
        this.checked = true;
      } else if (data.impLogo == 0) {
        this.checked = false;
      }
      this.alto = data.altoLogo;
      this.ancho = data.anchoLogo;
    },
    validateUpdateBank: function() {
      if (
        this.numerocuenta == this.changeNumeroCuenta &&
        this.cci == this.changeCci
      ) {
        return false;
      } else {
        return true;
      }
    },
    setActualizar: function() {
      this.actualizar = false;
    },
    setUpdateBank: function(data) {
      this.actualizar = true;
      let idbanco = "";
      let descripcionbanco = "";
      let idcuenta = "";
      let descripcioncuenta = "";
      let idmoneda = "";
      let codigomoneda = "";
      let descripcionmoneda = "";
      let simbolomoneda = "";
      this.Bancos.forEach(function(element) {
        if (element.descripcion === data.banco) {
          idbanco = element.id;
          descripcionbanco = element.descripcion;
        }
      });
      this.Cuentas.forEach(function(element) {
        if (element.descripcion === data.tipoCuenta) {
          idcuenta = element.id;
          descripcioncuenta = element.descripcion;
        }
      });
      this.tipoMoneda.forEach(function(element) {
        if (element.descripcion === data.moneda) {
          idmoneda = element.id;
          codigomoneda = element.codigo;
          descripcionmoneda = element.descripcion;
          simbolomoneda = element.simbolo;
        }
      });
      this.banco.id = idbanco;
      this.banco.descripcion = descripcionbanco;
      this.cuenta.id = idcuenta;
      this.cuenta.descripcion = descripcioncuenta;
      this.tipodemoneda.id = idmoneda;
      this.tipodemoneda.codigo = codigomoneda;
      this.tipodemoneda.descripcion = descripcionmoneda;
      this.tipodemoneda.simbolo = simbolomoneda;
      (this.numerocuenta = data.numeroCuenta),
        (this.changeNumeroCuenta = data.numeroCuenta),
        (this.cci = data.cci),
        (this.changeCci = data.cci),
        (this.idBanco = data.idInformacionBanco);
    },
    closeNameCuenta: function() {
      this.cuenta = { id: 0, descripcion: "CTA. CTE." };
    },
    closeNameBank: function() {
      this.banco = { id: 0, descripcion: "BCP" };
    },
    cerrarModalBanco: function() {
      (this.addbank = false), this.initBank();
    },
    listBanks: function() {
      this.isBusy = true;
      axios
        .post(process.env.VUE_APP_API_URL + "infobanco/listar", {
          token: this.$store.getters.userToken,
          limit: "10",
          order: "desc"
        })
        .then(
          response => (
            (this.isBusy = false), (this.listaBancos = response.data.data)
          )
        )
        .catch(error => (this.isBusy = false));
    },
    initBank: function() {
      (this.banco = { id: 0, descripcion: "BCP" }),
        (this.cuenta = { id: 0, descripcion: "CTA. CTE." }),
        (this.tipodemoneda = {
          id: "1",
          codigo: "PEN",
          descripcion: "SOLES",
          simbolo: "S/."
        }),
        (this.numerocuenta = ""),
        (this.cci = ""),
        (this.otrobanco = ""),
        (this.otracuenta = "");
    },
    addupdateBank: function(tipo) {
      let ruta = "";
      let bank = "";
      let account = "";
      if (tipo == 1) {
        ruta = "infobanco/insertar";
      } else if (tipo == 2) {
        ruta = "infobanco/actualizar";
      }
      this.banco.id == 13
        ? (bank = this.otrobanco)
        : (bank = this.banco.descripcion);
      this.cuenta.id == 5
        ? (account = this.otracuenta)
        : (account = this.cuenta.descripcion);
      (this.emitiendobank = false), (this.actualizandobank = false);
      axios
        .post(process.env.VUE_APP_API_URL + ruta, {
          token: this.$store.getters.userToken,
          id: this.idBanco,
          banco: bank,
          tipocuenta: account,
          moneda: this.tipodemoneda.descripcion,
          numerocuenta: this.numerocuenta,
          cci: this.cci
        })
        .then(
          response => (
            (this.addbank = false),
            (this.actualizar = false),
            (this.emitiendobank = true),
            (this.actualizandobank = true),
            this.listBanks(),
            this.initBank()
          )
        )
        .catch(
          error => (
            (this.emitiendobank = true),
            (this.actualizandobank = true),
            this.$snotify.error("Error")
          )
        );
    },
    predeleteBank: function(data) {
      this.$swal({
        title: "Eliminar Cuenta",
        text: "Seguro de eliminar esta cuenta " + data.numeroCuenta,
        icon: "error",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.deleteBank(data);
        } else {
        }
      });
    },
    deleteBank: function(data) {
      this.isBusy = true;
      axios
        .post(process.env.VUE_APP_API_URL + "infobanco/eliminar", {
          token: this.$store.getters.userToken,
          id: data.idInformacionBanco
        })
        .then(
          response => (
            this.listBanks(), this.$snotify.success(response.data.msg, "Exito")
          )
        )
        .catch(error => {});
    },
    backModify: function(val) {
      if (val == 1) {
        this.previoModificar = false;
        this.detraccionExiste = false;
        this.crearCuentaDetraccion = false;
      } else if (val == 0) {
        this.previoModificar = true;
        this.detraccionExiste = true;
        this.crearCuentaDetraccion = true;
      }
    },
    showAccountDetraction: function() {
      this.buscandoCtaDetraccion = false;
      this.detraccionExiste = true;
      this.botonesDetraccionExiste = false;
      this.previoModificar = true;
      this.vistaModificar = false;
      this.agregandoCuentaDet = false;
      axios
        .post(process.env.VUE_APP_API_URL + "cuenta/detraccion/buscarcuenta", {
          token: this.$store.getters.userToken
        })
        .then(
          response => (
            (this.cuentaDetracionAdmin = response.data.response),
            this.responseAccountDetraction(response.data.response),
            (this.buscandoCtaDetraccion = true)
          )
        )
        .catch(
          error => (
            (this.buscandoCtaDetraccion = true),
            (this.detraccionExiste = false),
            (this.botonesDetraccionExiste = true),
            (this.agregandoCuentaDet = true)
          )
        );
    },
    responseAccountDetraction: function(val) {
      if (val.length == 0) {
        (this.buscandoCtaDetraccion = true),
          (this.detraccionExiste = false),
          (this.botonesDetraccionExiste = true),
          (this.agregandoCuentaDet = true),
          (this.previoModificar = false),
          (this.vistaModificar = false),
          (this.crearCuentaDetraccion = true);
      } else if (val.length > 0) {
        (this.buscandoCtaDetraccion = true),
          (this.detraccionExiste = true),
          (this.botonesDetraccionExiste = false),
          (this.previoModificar = true),
          (this.vistaModificar = true);
      }
    },
    addAccountDetraction: function(val) {
      if (val == 1) {
        this.agregandoCuentaDet = false;
      }
      axios
        .post(
          process.env.VUE_APP_API_URL + "cuenta/detraccion/insertarcuenta",
          {
            token: this.$store.getters.userToken,
            cuenta: this.cuentaDetraccion
          }
        )
        .then(
          response => (
            (this.modificando = false),
            this.$snotify.success(response.data.msg, "Éxito"),
            (this.cuentaDetraccion = ""),
            (this.agregandoCuentaDet = true),
            this.showAccountDetraction()
          )
        )
        .catch(
          error => (
            (this.modificando = false),
            (this.cuentaDetraccion = ""),
            (this.agregandoCuentaDet = true),
            this.$snotify.error(response.data.msg, "Error")
          )
        );
    },
    updateAccountDetraction: function() {
      if (this.cuentaDetraccion == "") {
        this.$snotify.warning("Ingrese una cuenta de detraccion", "Cuidado");
      } else {
        this.$swal({
          title: "Modificar Cuenta",
          text:
            "Cuidado! Modificar la cuenta de detraccion hara que la recaudacion de determinados tributos cambien de destino",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            this.modificando = true;
            this.addAccountDetraction(2);
          } else {
          }
        });
      }
    },
    updateClient() {
      this.updateClienteDatos = true;

      const documento = this.documentoUser.trim();

      if (!/^\d+$/.test(documento)) {
        this.$snotify.warning(
          "El documento solo debe contener números.",
          "Cuidado !"
        );
        this.updateClienteDatos = false;
        return;
      }

      let url = "";
      let data = {
        token: this.$store.getters.userToken
      };

      if (documento.length === 8) {
        // DNI
        url = process.env.VUE_APP_API_URL + "receptores/actualizar/dni";
        data.dni = documento;
      } else if (documento.length === 11) {
        // RUC
        url = process.env.VUE_APP_API_URL + "receptores/actualizar";
        data.ruc = documento;
      } else {
        this.updateClienteDatos = false;
        this.$snotify.error(
          "Ingrese un DNI (8 dígitos) o un RUC (11 dígitos) válido.",
          "Error"
        );
        return;
      }

      axios
        .post(url, data)
        .then(response => {
          this.updateClienteDatos = false;

          if (documento.length === 8) {
            // Respuesta del endpoint DNI
            this.razon_social = response.data.response.nombre;
            this.domicilio_fiscal = "";
          } else {
            // Respuesta del endpoint RUC
            this.razon_social = response.data.response.razonSocial;
            this.domicilio_fiscal =
              response.data.response.direccionReferencia;
          }

          this.$snotify.success(response.data.msg, "Éxito");
        })
        .catch(() => {
          this.updateClienteDatos = false;

          this.$snotify.error(
            "Por favor verifique el documento ingresado.",
            "Error"
          );
        });
    },
    // updateClient: function() {
    //   (this.updateClienteDatos = true),
    //     axios
    //       .post(process.env.VUE_APP_API_URL + "receptores/actualizar", {
    //         token: this.$store.getters.userToken,
    //         ruc: this.documentoUser
    //       })
    //       .then(
    //         response => (
    //           (this.updateClienteDatos = false),
    //           (this.razon_social = response.data.response.razonSocial),
    //           (this.domicilio_fiscal = response.data.response.direccionReferencia),
    //           this.$snotify.success(response.data.msg, "Éxito")
    //         )
    //       )
    //       .catch(
    //         error => (
    //           (this.updateClienteDatos = false),
    //           this.$snotify.error(
    //             "Por favor verifique el RUC que ingreso, de ser correcto comuniquese con el area técnica",
    //             "Error"
    //           )
    //         )
    //       );
    // },
    userData: function() {
      this.user = this.$store.getters.userData;
    },
    setStore: function(data) {
      (this.modalupdate = true),
        (this.editidstore = data.idEstablecimiento),
        (this.editnamestore = data.nombreEstablecimiento),
        (this.editcodestore = data.codigoEstablecimiento),
        (this.ubigeoPartida = data.ubigeo),
        (this.direcUbigeo = data.direccion);
    },
    borrarEstablecimiento(value){ 
      if(this.stores.length < 2){
         this.$snotify.warning("No puede borrar la última información", "Cuidado")
      }else{
        axios
        .post(process.env.VUE_APP_API_URL + "establecimientos/borrar",{
          token: this.$store.getters.userToken,
          id: value.idEstablecimiento
        })
        .then(response=>(
         this.$snotify.success(response.data.msg),
         this.getStores()
        ))
        .catch(error=>(
          this.$snotify.error(error.response.data.msg, "Error")
        ));
      }
    },
    getUsers: function() {
      this.loadingusers = true;
      axios
        .post(process.env.VUE_APP_API_URL + "usuario/listar", {
          token: this.$store.getters.userToken,
          page: this.ucurrentPage,
          limit: this.uperPage
        })
        .then(
          response => (
            (this.users = response.data.users.data),
            (this.loadingusers = false),
            (this.urows = response.data.users.total),
            this.modaluseredit = false,
            this.modalActualizarUsuario()
          )
        )
        .catch(error => {
          this.loadingusers = false;
        });
    },
    getStores: function() {
      this.loadingstores = true;
      axios
        .post(process.env.VUE_APP_API_URL + "establecimientos/listar", {
          token: this.$store.getters.userToken,
          idEmisor: this.$store.getters.userData.idEmisor,
          page: this.scurrentPage,
          limit: this.sperPage
        })
        .then(
          response => (
            (this.stores = response.data.data),
            (this.loadingstores = false),
            (this.srows = response.data.total)
          )
        )
        .catch(error => (this.loadingstores = false));
    },
    saveStore: function() {
      this.loadingstores2 = true;
      axios
        .post(process.env.VUE_APP_API_URL + "establecimientos/crear", {
          token: this.$store.getters.userToken,
          name: this.namestore,
          code: this.codestore,
          ubigeo: this.ubigeoPartida,
          direccion: this.direcUbigeo
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Éxito"),
            (this.loadingstores2 = false),
            (this.modalstore = false),
            (this.namestore = ""),
            (this.codestore = ""),
            this.getStores()
          )
        )
        .catch(function(error) {
          this.$snotify.error(error.response.data.msg, "Error"),
            (this.loadingstores2 = false);
        });
    },
    updateStore: function() {
      this.loadingstores3 = true;
      axios
        .post(process.env.VUE_APP_API_URL + "establecimientos/actualizar", {
          token: this.$store.getters.userToken,
          id: this.editidstore,
          updatename: this.editnamestore,
          updatecode: this.editcodestore,
          ubigeo: this.ubigeoPartida,
          direccion:this.direcUbigeo
        })
        .then(
          response => (
            (this.stores = response.data.data),
            this.$snotify.success(response.data.msg, "Éxito"),
            (this.loadingstores3 = false),
            (this.modalupdate = false),
            (this.editnamestore = ""),
            (this.editcodestore = ""),
            this.getStores()
          )
        )
        .catch(function(error) {
          this.$snotify.error(error.response.data.msg, "Error"),
            (this.loadingstores3 = false);
        });
    },
    changepwd: function() {
      !this.change ? (this.change = true) : (this.change = false);
    },
    checkpwd1: function() {
      let state;
      this.personalizar.claveNueva1 !== "" ? (state = true) : (state = false);
      return state;
    },
    checkpwd2: function() {
      let state;
      this.personalizar.claveNueva2 !== "" &&
      this.personalizar.claveNueva1 == this.personalizar.claveNueva2
        ? (state = true)
        : (state = false);
      return state;
    },
    btnenabled: function() {
      let state;
      this.validarPassword() && this.checkpwd2() ? (state = true) : (state = false);
      return state;
    },
    sendNewPass: function() {
      this.loading = true;
      axios
        .post(process.env.VUE_APP_API_URL + "usuario/clave/actualizar", {
          token: this.$store.getters.userToken,
          nuevaclave: this.personalizar.claveNueva1
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Éxito"),
            (this.loading = false),
            (this.personalizar.claveNueva1 = ""),
            (this.personalizar.claveNueva2 = ""),
            (this.claveNueva2 = ""),
            (this.tabs = 0),
            (this.change = false)
          )
        )
        .catch(error => (this.loading = false));
    },
    getSeries: function() {
      this.loadingseries = true;
      axios
        .post(process.env.VUE_APP_API_URL + "series/pordoc", {
          token: this.$store.getters.userToken
        })
        .then(
          response => (
            (this.seriesall = response.data.info), (this.loadingseries = false)
          )
        )
        .catch(error => (this.loadingseries = false));
    },
    getUser: function(item,value) {
      if(item.perfil != null){
        this.modaluseredit = true;
        this.edituser = item;
        if (!item.perfil.seriesemUsuario) {
          item.perfil.seriesemUsuario = {
            "1": [],
            "2": [],
            "3": [],
            "4": [],
            "5": [],
            "6": [],
            "7": [],
            "8": [],
            "9": [],
            "10": [],
            "11": [],
            "12": [],
            "13": [],
            "14": []
            
          };
        }
        if (!item.perfil.seriesconUsuario) {
          item.perfil.seriesconUsuario = {
            "1": [],
            "2": [],
            "3": [],
            "4": [],
            "5": [],
            "6": [],
            "7": [],
            "8": [],
            "9": [],
            "10": [],
            "11": [],
            "12": [],
            "13": [],
            "14": []
          };
        }
      }else{
        //crear perfil para usuarios 
        axios.post(process.env.VUE_APP_API_URL + "usuario/perfil/agregar/" + item.idUsuario,{
          token: this.$store.getters.userToken,
          appUsuario:item.appUsuario,
          apmUsuario:item.apmUsuario,
          nomUsuario:item.nomUsuario,
          emailUsuario:item.emailUsuario
        })
        .then(response=>(
          this.getUsers()
        ))
        .catch(error=>(
          console.log(error)
        ))    
      }
    },
    storeUser: function() {
      this.loadinguser = true;
      axios
        .post(process.env.VUE_APP_API_URL + "usuario/crear", {
          token: this.$store.getters.userToken,
          usuario: this.newuser.username,
          descripcion: "Usuario creado desde el APP",
          rol: this.newuser.perfil.rol,
          apaterno: this.newuser.perfil.appUsuario,
          amaterno: this.newuser.perfil.apmUsuario,
          nombres: this.newuser.perfil.nomUsuario,
          email: this.newuser.perfil.correo,
          establecimiento: this.newuser.perfil.establecimiento,
          s1: this.seriesfacturas,
          s2: this.seriesboletas,
          s3: this.seriesnotascf,
          s4: this.seriesnotascb,
          s5: this.seriesnotasdf,
          s6: this.seriesnotasdb,
          s7: this.seriesgr,
          s8: this.seriesp,
          s9: this.seriesoc,
          s10: this.seriesgc,
          s11: this.seriesop,
          s12: this.seriesnv,
          s13: this.seriesgt,
          s14: this.seriests
          
        })
        .then(
          response => (
            this.$snotify.success("Usuario creado exitosamente", "Éxito"),
            (this.loadinguser = false),
            this.modaluser = false,
            this.getUsers()
          )
        )
        .catch(
          error => (
            (this.loadinguser = false),
            this.$snotify.error(error.response.data.msg, "Error")
          )
        );
    },
    updateUser: function() {  
        this.loadinguser2 = true;
      if(this.edituser.username && this.edituser.perfil.idEstablecimiento && this.edituser.perfil.appUsuario && 
          this.edituser.perfil.apmUsuario && this.edituser.perfil.nomUsuario && this.edituser.perfil.emailUsuario){ 

        if(this.edituser.perfil.rolUsuario == 1){
          let serie1em = []
          this.seriesall[1].forEach(function(element){
          serie1em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[1] = serie1em 
          this.edituser.perfil.seriesconUsuario[1] = serie1em
          /*****/
          let serie2em = []
          this.seriesall[2].forEach(function(element){
          serie2em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[2] = serie2em 
          this.edituser.perfil.seriesconUsuario[2] = serie2em
          /*****/
          let serie3em = []
          this.seriesall[3].forEach(function(element){
          serie3em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[3] = serie3em 
          this.edituser.perfil.seriesconUsuario[3] = serie3em
          /*****/
          let serie4em = []
          this.seriesall[4].forEach(function(element){
          serie4em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[4] = serie4em 
          this.edituser.perfil.seriesconUsuario[4] = serie4em
          /*****/
          let serie5em = []
          this.seriesall[5].forEach(function(element){
          serie5em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[5] = serie5em 
          this.edituser.perfil.seriesconUsuario[5] = serie5em
          /*****/
          let serie6em = []
          this.seriesall[6].forEach(function(element){
          serie6em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[6] = serie6em 
          this.edituser.perfil.seriesconUsuario[6] = serie6em
          /*****/
          let serie7em = []
          this.seriesall[7].forEach(function(element){
          serie7em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[7] = serie7em 
          this.edituser.perfil.seriesconUsuario[7] = serie7em
          /*****/
          let serie8em = []
          this.seriesall[8].forEach(function(element){
          serie8em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[8] = serie8em 
          this.edituser.perfil.seriesconUsuario[8] = serie8em
          /*****/
          let serie9em = []
          this.seriesall[9].forEach(function(element){
          serie9em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[9] = serie9em 
          this.edituser.perfil.seriesconUsuario[9] = serie9em
          /*****/
          let serie10em = []
          this.seriesall[10].forEach(function(element){
          serie10em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[10] = serie10em 
          this.edituser.perfil.seriesconUsuario[10] = serie10em
          /*****/
          let serie11em = []
          this.seriesall[11].forEach(function(element){
          serie11em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[11] = serie11em 
          this.edituser.perfil.seriesconUsuario[11] = serie11em
          /*****/
          let serie12em = []
          this.seriesall[12].forEach(function(element){
          serie12em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[12] = serie12em 
          this.edituser.perfil.seriesconUsuario[12] = serie12em
          /*****/
          let serie13em = []
          this.seriesall[13].forEach(function(element){
          serie13em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[13] = serie13em 
          this.edituser.perfil.seriesconUsuario[13] = serie13em
          /******/
          let serie14em = []
          this.seriesall[14].forEach(function(element){
          serie14em.push(element.idSerie)
          })
          this.edituser.perfil.seriesemUsuario[14] = serie13em 
          this.edituser.perfil.seriesconUsuario[14] = serie13em
        }else{
      
          if(this.edituser.perfil.seriesemUsuario[1].length > this.edituser.perfil.seriesconUsuario[1].length){
              this.edituser.perfil.seriesconUsuario[1] = this.edituser.perfil.seriesemUsuario[1];
          }else if(this.edituser.perfil.seriesconUsuario[1].length > this.edituser.perfil.seriesemUsuario[1].length){

          }
          if(this.edituser.perfil.seriesemUsuario[2].length > this.edituser.perfil.seriesconUsuario[2].length){
              this.edituser.perfil.seriesconUsuario[2] = this.edituser.perfil.seriesemUsuario[2];
          }else if(this.edituser.perfil.seriesconUsuario[2].length > this.edituser.perfil.seriesemUsuario[2].length){

          }
          if(this.edituser.perfil.seriesemUsuario[3].length > this.edituser.perfil.seriesconUsuario[3].length){
              this.edituser.perfil.seriesconUsuario[3] = this.edituser.perfil.seriesemUsuario[3];
          }
          else if(this.edituser.perfil.seriesconUsuario[3].length > this.edituser.perfil.seriesemUsuario[3].length){
              
          }
          if(this.edituser.perfil.seriesemUsuario[4].length > this.edituser.perfil.seriesconUsuario[4].length){
              this.edituser.perfil.seriesconUsuario[4] = this.edituser.perfil.seriesemUsuario[4];
          }else if (this.edituser.perfil.seriesconUsuario[4].length > this.edituser.perfil.seriesemUsuario[4].length){

          }
          if(this.edituser.perfil.seriesemUsuario[5] > this.edituser.perfil.seriesconUsuario[5]){
              this.edituser.perfil.seriesconUsuario[5] = this.edituser.perfil.seriesemUsuario[5];
          }else if(this.edituser.perfil.seriesconUsuario[5] > this.edituser.perfil.seriesemUsuario[5]){

          }
          if(this.edituser.perfil.seriesemUsuario[6] > this.edituser.perfil.seriesconUsuario[6]){
            this.edituser.perfil.seriesconUsuario[6] = this.edituser.perfil.seriesemUsuario[6];
          }else if(this.edituser.perfil.seriesconUsuario[6] > this.edituser.perfil.seriesemUsuario[6]){

          }
          if(this.edituser.perfil.seriesemUsuario[7] > this.edituser.perfil.seriesconUsuario[7]){
              this.edituser.perfil.seriesconUsuario[7] = this.edituser.perfil.seriesemUsuario[7];
          }else if(this.edituser.perfil.seriesconUsuario[7] > this.edituser.perfil.seriesemUsuario[7]){

          }
          if(this.edituser.perfil.seriesemUsuario[8] > this.edituser.perfil.seriesconUsuario[8]){
              this.edituser.perfil.seriesconUsuario[8] = this.edituser.perfil.seriesemUsuario[8];
          }else if(this.edituser.perfil.seriesconUsuario[8] > this.edituser.perfil.seriesemUsuario[8]){

          }
          if(this.edituser.perfil.seriesemUsuario[9] > this.edituser.perfil.seriesconUsuario[9]){
              this.edituser.perfil.seriesconUsuario[9] = this.edituser.perfil.seriesemUsuario[9];
          }else if(this.edituser.perfil.seriesconUsuario[9] > this.edituser.perfil.seriesemUsuario[9]){

            }
          if(this.edituser.perfil.seriesemUsuario[10] > this.edituser.perfil.seriesconUsuario[10]){
              this.edituser.perfil.seriesconUsuario[10] = this.edituser.perfil.seriesemUsuario[10];
          }else if(this.edituser.perfil.seriesconUsuario[10] > this.edituser.perfil.seriesemUsuario[10]){

          }
          if(this.edituser.perfil.seriesemUsuario[11] > this.edituser.perfil.seriesconUsuario[11]){
              this.edituser.perfil.seriesconUsuario[11] = this.edituser.perfil.seriesemUsuario[11];
          }else if(this.edituser.perfil.seriesconUsuario[11] > this.edituser.perfil.seriesemUsuario[11]){

          }
          if(this.edituser.perfil.seriesemUsuario[12] > this.edituser.perfil.seriesconUsuario[12]){
              this.edituser.perfil.seriesconUsuario[12] = this.edituser.perfil.seriesemUsuario[12];
          }else if(this.edituser.perfil.seriesconUsuario[12] > this.edituser.perfil.seriesemUsuario[12]){

          }
          if(this.edituser.perfil.seriesemUsuario[13] > this.edituser.perfil.seriesconUsuario[13]){
              this.edituser.perfil.seriesconUsuario[13] = this.edituser.perfil.seriesemUsuario[13];
          }else if(this.edituser.perfil.seriesconUsuario[13] > this.edituser.perfil.seriesemUsuario[13]){

          }
          if(this.edituser.perfil.seriesemUsuario[14] > this.edituser.perfil.seriesconUsuario[14]){
              this.edituser.perfil.seriesconUsuario[14] = this.edituser.perfil.seriesemUsuario[14];
          }else if(this.edituser.perfil.seriesconUsuario[14] > this.edituser.perfil.seriesemUsuario[14]){

          }
        }         
      axios
        .post(
          process.env.VUE_APP_API_URL +
            "usuario/actualizar/" +
            this.edituser.idUsuario,
          {
            token: this.$store.getters.userToken,
            usuario: this.edituser.username,
            descripcion: "Usuario creado desde el APP",
            rol: this.edituser.perfil.rolUsuario,
            apaterno: this.edituser.perfil.appUsuario,
            amaterno: this.edituser.perfil.apmUsuario,
            nombres: this.edituser.perfil.nomUsuario,
            email: this.edituser.perfil.emailUsuario,
            establecimiento: this.edituser.perfil.idEstablecimiento,
            s1: this.edituser.perfil.seriesemUsuario[1],
            s2: this.edituser.perfil.seriesemUsuario[2],
            s3: this.edituser.perfil.seriesemUsuario[3],
            s4: this.edituser.perfil.seriesemUsuario[4],
            s5: this.edituser.perfil.seriesemUsuario[5],
            s6: this.edituser.perfil.seriesemUsuario[6],
            s7: this.edituser.perfil.seriesemUsuario[7],
            s8: this.edituser.perfil.seriesemUsuario[8],
            s9: this.edituser.perfil.seriesemUsuario[9],
            s10: this.edituser.perfil.seriesemUsuario[10],
            s11: this.edituser.perfil.seriesemUsuario[11],
            s12: this.edituser.perfil.seriesemUsuario[12],
            s13: this.edituser.perfil.seriesemUsuario[13],
            s14: this.edituser.perfil.seriesemUsuario[14],
            sc1: this.edituser.perfil.seriesconUsuario[1],
            sc2: this.edituser.perfil.seriesconUsuario[2],
            sc3: this.edituser.perfil.seriesconUsuario[3],
            sc4: this.edituser.perfil.seriesconUsuario[4],
            sc5: this.edituser.perfil.seriesconUsuario[5],
            sc6: this.edituser.perfil.seriesconUsuario[6],
            sc7: this.edituser.perfil.seriesconUsuario[7],
            sc8: this.edituser.perfil.seriesconUsuario[8],
            sc9: this.edituser.perfil.seriesconUsuario[9],
            sc10: this.edituser.perfil.seriesconUsuario[10],
            sc11: this.edituser.perfil.seriesconUsuario[11],
            sc12: this.edituser.perfil.seriesconUsuario[12],
            sc13: this.edituser.perfil.seriesconUsuario[13],
            sc14: this.edituser.perfil.seriesconUsuario[14]
          }
        )
        .then(
          response => (
            this.$snotify.success("Usuario actualizado exitosamente", "Éxito"),
            (this.loadinguser2 = false),
            (this.modaluseredit = false),
            this.getUsers()
          )
        )
        .catch(
          error => (
            (this.loadinguser2 = false),
            this.$snotify.error(error.response.data.msg, "Error")
          )
        );
      }else{
        this.$snotify.warning("Completar todos los campos", "Cuidado !"),
        this.loadinguser2 = false;
      }
    },

    //sett
    onFileChange(e) {
      const file = e.target.files[0];
      this.urlimg = URL.createObjectURL(file);
    },
    // userData: function () {
    //   this.user =  this.$store.getters.userData
    // },
    changeimg: function() {
      !this.changelogo ? (this.changelogo = true) : (this.changelogo = false);
    },
    saveimg: function() {
      this.savinglogo = true;
      let formData = new FormData();
      formData.append("token", this.$store.getters.userToken);
      formData.append("image", this.logo);
      axios
        .post(process.env.VUE_APP_API_URL + "cuenta/cambiarlogo", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Éxito"),
            // this.$snotify.info('Vamos a actualizar la página para cargar los cambios', 'Aviso'),
            (this.tabs = 0),
            (this.savinglogo = false)
            // window.location.reload(true)
          )
        )
        .catch(function(error) {
          this.savinglogo = false;
        });
    },
    getConfigdoc: function() {
      this.cargarconfigdoc = true;
      axios
        .post(process.env.VUE_APP_API_URL + "documento/configuracion", {
          token: this.$store.getters.userToken
        })
        .then(
          response => (
            (this.size = response.data.configuration.pdfFormato),
            (this.height = response.data.configuration.pdfAlto),
            (this.witdh = response.data.configuration.pdfAncho),
            (this.orientation = response.data.configuration.pdfOrientacion),
            (this.cargarconfigdoc = false)
          )
        )
        .catch(function(error) {
          this.cargarconfigdoc = false;
        });
    },
    getConfigcode: function() {
      this.cargarconfigcode = true;
      axios
        .post(process.env.VUE_APP_API_URL + "documento/codigo", {
          token: this.$store.getters.userToken
        })
        .then(
          response => (
            (this.typecode = response.data.typecode.tipoCodigoBarra),
            (this.cargarconfigcode = false)
          )
        )
        .catch(function(error) {
          this.cargarconfigcode = false;
        });
    },
    setConfigdoc: function() {
      this.cargarconfigdoc2 = true;
      axios
        .post(
          process.env.VUE_APP_API_URL + "documento/configuracion/actualizar",
          {
            token: this.$store.getters.userToken,
            pdfOrientacion: this.orientation,
            pdfFormato: this.size,
            pdfAncho: this.witdh,
            pdfAlto: this.height
          }
        )
        .then(
          response => (
            // this.$snotify.success('')
            (this.cargarconfigdoc2 = false), this.getConfigdoc()
          )
        )
        .catch(function(error) {
          this.cargarconfigdoc2 = false;
        });
    },
    setConfigcode: function() {
      this.cargarconfigcode2 = true;
      axios
        .post(process.env.VUE_APP_API_URL + "documento/codigo/actualizar", {
          token: this.$store.getters.userToken,
          tipoCodigoBarra: this.typecode
        })
        .then(
          response => ((this.cargarconfigcode2 = false), this.getConfigcode())
        )
        .catch(function(error) {
          this.cargarconfigcode2 = false;
        });
    },
    openModalSerie: function(doc) {
      this.modalserie = true;
      this.typecomprobant = doc;
    },
    openModalSerieUpdate: function(doc, data) {
      if(data.estadoSerie === 2){
        this.mostrarSerie = true;
      }else{
        this.mostrarSerie = false;
      }
      this.modalserieupdate = true;
      this.typecomprobant2 = doc;
      this.serie2 = data.nombreSerie.substring(1);
      this.startin2 = data.ultimoSerie;
      this.idserie = data.idSerie;
    },
    openModalSerieDelete: function(doc, data) {
      this.modalseriedelete = true;
      this.typecomprobant3 = doc;
      this.serie3 = data.nombreSerie;
      this.idserie = data.idSerie;
    },
    getPrefixDoc: function(value) {
      if (value == 1 || value == 3 || value == 5) {
        return "F";
      }
      if (value == 2 || value == 4 || value == 6) {
        return "B";
      }
      if (value == 7) {
        return "T";
      }
      if (value == 8) {
        return "P";
      }
      if (value == 9) {
        return "OC";
      }
      if (value == 10) {
        return "GC";
      }
      if (value == 11) {
        return "OP";
      }
      if (value == 12) {
        return "NV";
      }
      if (value == 13) {
        return "V";
      }
      if (value == 14) {
        return "X";
      }
    },
    storeSerie: function() {
      this.cargarconfigserie = true;
      let prefix = this.getPrefixDoc(this.typecomprobant);
      axios
        .post(process.env.VUE_APP_API_URL + "series/registrar", {
          token: this.$store.getters.userToken,
          nombre: prefix + this.serie,
          ultimo: this.startin,
          tipo: this.typecomprobant
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Éxito"),
            (this.cargarconfigserie = false),
            this.getSeriesbyType(this.typecomprobant),
            (this.tabIndex = this.typecomprobant - 1),
            (this.modalserie = false),
            (this.serie = "")
          )
        )
        .catch(
          error => (
            this.$snotify.error(error.response.data.msg, "Error"),
            (this.cargarconfigserie = false)
          )
        );
    },
    updateSerie: function() {
      this.cargarconfigserie2 = true;
      let prefix = this.getPrefixDoc(this.typecomprobant2);
      axios
        .post(
          process.env.VUE_APP_API_URL + "series/actualizar/" + this.idserie,
          {
            token: this.$store.getters.userToken,
            nombre: prefix + this.serie2,
            ultimo: this.startin2,
            tipo: this.typecomprobant2,
            estadoSerie: this.mostrarSerieValor
          }
        )
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Éxito"),
            (this.cargarconfigserie2 = false),
            this.getSeriesbyType(this.typecomprobant2),
            (this.tabIndex = this.typecomprobant - 1),
            (this.modalserieupdate = false)
          )
        )
        .catch(
          error => (
            this.$snotify.error(error.response.data.msg, "Error"),
            (this.cargarconfigserie2 = false)
          )
        );
    },
    deleteSerie: function() {
      this.cargarconfigserie3 = true;
      axios
        .post(process.env.VUE_APP_API_URL + "series/eliminar/" + this.idserie, {
          token: this.$store.getters.userToken
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Éxito"),
            (this.cargarconfigserie3 = false),
            this.getSeriesbyType(this.typecomprobant3),
            // this.tabIndex = this.typecomprobant-1,
            (this.modalseriedelete = false)
          )
        )
        .catch(
          error => (
            this.$snotify.error(error.response.data.msg, "Error"),
            (this.cargarconfigserie3 = false)
          )
        );
    },
    getSeriesbyType: function(type) {
      var table = {
        info: {
          data: [],
          currentpage: 1,
          from: 0,
          to: 0,
          limit: 10,
          total: 0
        },
        cargar: false
      };
      switch (type) {
        case 1:
          table = this.series.type1;
          break;
        case 2:
          table = this.series.type2;
          break;
        case 3:
          table = this.series.type3;
          break;
        case 4:
          table = this.series.type4;
          break;
        case 5:
          table = this.series.type5;
          break;
        case 6:
          table = this.series.type6;
          break;
        case 7:
          table = this.series.type7; //guia remision
          break;
        case 8:
          table = this.series.type8; //proforma
          break;
        case 9:
          table = this.series.type9; // orden compra
          break;
        case 10:
          table = this.series.type10; // guia de control 
          break;
        case 11:
          table = this.series.type11;// orden pago 
          break;
        case 12:
          table = this.series.type12; // nota de venta
          break;
        case 13:
          table = this.series.type13; // nota de venta
          break;
        case 14:
          table = this.series.type14; // Ticket Suministro
          break;
      }
      table.cargar = true;

      axios
        .post(process.env.VUE_APP_API_URL + "series/listar/tipo", {
          token: this.$store.getters.userToken,
          tipo: type,
          page: table.info.currentpage
        })
        .then(
          response => (
            (table.info.data = response.data.data),
            (table.info.totalRows = table.info.data.length),
            (table.info.currentpage = response.data.current_page),
            (table.info.from = response.data.from),
            (table.info.to = response.data.to),
            (table.info.limit = response.data.per_page),
            (table.info.total = response.data.total),
            (table.cargar = false)
          )
        )
        .catch(function(error) {
          table.cargar = false;
        });
    },
    ServicioRuc(){
      axios
      .post(process.env.VUE_APP_API_URL + "v2/cliente/servicios", {
          idEmisor: this.$store.getters.userData.idEmisor,
          codigo:   this.cod
        })
        .then(response =>(
          this.validarServicio = response.data.data,
          this.valCodRuc(),
          this.validarContador()
        ))
        .catch(error=>(
          console.log('error')
        ));
    },
    valCodRuc(){
      let val = false
      this.validarServicio.forEach(function(element){
        if(element.Codigo =="QUIPU" || element.Codigo =="CONTADOR"){
          val = true
        }
      })
      this.servicio = val
    },
    modalService(){
      this.modalServicio = true;
    },
    cerrarServicio(){
      this.modalServicio = false;
    },
    searchProvinceOrigen: function () {
      this.provOrigenCargando = true
        axios
          .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
              token: this.$store.getters.userToken,
              department: this.departamentoUbigeo
          })
          .then(response => (
              this.provOrigenCargando = false,
              this.listProvinceOrigen = response.data                       
          ))
          .catch(error => {})
    },
    searchDistrictOrigen: function (value) {
      this.distOrigenCargando = value   
        axios
          .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
            token: this.$store.getters.userToken,
            department: this.departamentoUbigeo,
            province: this.provinciaUbigeo
          })
          .then(response => (
          this.listDistrictOrigen = response.data,
          this.distOrigenCargando = false
          ))
          .catch(error => {})
    },
    autorizarContador(){
      axios
      .post(process.env.VUE_APP_API_URL + "contador/asociar",{
        token: this.$store.getters.userToken,
        idContador: this.autorizar
      })
      .then(response=>(
        this.$snotify.success(response.data.msg, "Éxito"),
        this.mostrarAsociados(),
        this.autorizar = ''
      ))
      .catch(error=>(
         this.$snotify.error(error.response.data.msg, "Error")
      ))
    },
    mostrarAsociados(){
      this.cargando = true;
      let contadorAsociados = {};
      axios
      .post(process.env.VUE_APP_API_URL + "contador/asociado",{
         token: this.$store.getters.userToken,
      })
      .then(response=>(
        this.cargando = false,
        contadorAsociados = response.data.response,
        this.listaAsociadosTerminados = response.data.anteriores,
        this.listaAsociadosTerminados.push(contadorAsociados),//se agrega el RUC asocioado a los anteriores
        this.listadoInvertido= [...this.listaAsociadosTerminados].reverse()
      ))
      .catch(error=>(
        //  this.$snotify.error(error.response.data.msg, "Error")
        console.log()
      ))
    },
    validarContador(){
      let val = false
      this.validarServicio.forEach(function(element){
        if(element.Codigo =="CONTADOR"){
          val = true
        }
      })
      this.servicioConta = val
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.estado == '1') return 'table-success'
    },
    listarInfoUsuario(){
      axios
      .post(process.env.VUE_APP_API_URL + "movil/informacioncliente/listar",{
        token: this.$store.getters.userToken
      })
      .then(response =>(
        this.listaUsuarioInfo = response.data,
        this.mostrarUsuario()
      ))
      .catch(error => (console.log(error.response.data)
      ));
    },
    mostrarUsuario(){
      // this.selectedInfoUsuario = 0
      
    },
    actualizarMostrar(){
      axios
      .post(process.env.VUE_APP_API_URL + "movil/informacioncliente/actualizar",{
        token: this.$store.getters.userToken,    
        principal: 1,
        idInformacionMovil:this.idmovil
      })
      .then(response=>(
        this.getDataImpresion()
      ))
      .catch(error => (
        console.log(error.responde.data)
      ))
    },
    actualizarUser(){
      axios
      .post(process.env.VUE_APP_API_URL + "movil/informacioncliente/actualizar",{
        token: this.$store.getters.userToken,    
        telefono:this.telefono,
        nombrecomercial:this.nombreComercial,
        direccion:this.direccion,
        paginaweb:this.paginaWeb,
        correo:this.correo,
        textopersonalizado1:this.textoPersonalizado1,
        textopersonalizado2:this.textoPersonalizado2,
        nombreInformacion:this.nombreSucursal,
        principal: 1,
        idInformacionMovil:this.idmovil,
        ancho: parseFloat(this.ancho),
        alto: parseFloat(this.alto),
        estadologo: this.checked,
      })
      .then(response=>(
        this.getDataImpresion(),
        this.listarInfoUsuario(),
        this.$snotify.success(response.data.msg, "Exito")
      ))
      .catch(error => (
        console.log(error.responde.data)
      ))
    },
    validarInfo(){
      if(this.nombreSucursal == null || this.nombreSucursal == '' || this.nombreComercial == null || this.nombreComercial == '' ){
        return true
      }else{
        return false
      }
    },
    validarlogo(){
      if(this.checked){
        if(this.alto == ''){
          return true
                 
        }else{
          return false
                 
        }
      }
    },
    verGrabarNuevo(){
      this.verActualizar = false;
      this.nombreSucursal = "";
      this.nombreComercial = "";
      this.direccion = "";
      this.telefono = "";
      this.paginaWeb ="";
      this.correo = "";
      this.textoPersonalizado1 = "";
      this.textoPersonalizado2 = "";   
    },
    modalActualizarUsuario(){
      let t = this.$store.getters.userData.username
      if(this.$store.getters.getemailpanel!=''){
        let datosEditAdmin = {}
        this.users.forEach(function(element){       
          if(element.username == t){
            datosEditAdmin = element
            if (!datosEditAdmin.perfil.seriesemUsuario) {
          datosEditAdmin.perfil.seriesemUsuario = {
            "1": [],
            "2": [],
            "3": [],
            "4": [],
            "5": [],
            "6": [],
            "7": [],
            "8": [],
            "9": [],
            "10": [],
            "11": [],
            "12": [],
            "13": [],
            "14": []
          };
        }
        if (!datosEditAdmin.perfil.seriesconUsuario) {
          datosEditAdmin.perfil.seriesconUsuario = {
            "1": [],
            "2": [],
            "3": [],
            "4": [],
            "5": [],
            "6": [],
            "7": [],
            "8": [],
            "9": [],
            "10": [],
            "11": [],
            "12": [],
            "13": [],
            "14": []
          };
        }
          }
        })
        this.edituser = datosEditAdmin
        let valores = {}
        
        valores = this.$store.getters.getemailpanel
        // this.visible = valores.visible
        this.modaluseredit = valores.modaluseredit;
      }   
    },
    abrirModal(){
      this.modaluser = true
    },
    validaseries(){
      if(this.edituser.perfil.rolUsuario!=1){
        if(this.edituser.perfil.rolUsuario!=3){
            if(this.modaluseredit){
              if(this.edituser.perfil.seriesemUsuario[1] > 0 || 
                this.edituser.perfil.seriesemUsuario[2] > 0 || 
                this.edituser.perfil.seriesemUsuario[3] > 0 || 
                this.edituser.perfil.seriesemUsuario[4] > 0 || 
                this.edituser.perfil.seriesemUsuario[5] > 0 || 
                this.edituser.perfil.seriesemUsuario[6] > 0 || 
                this.edituser.perfil.seriesemUsuario[7] > 0 || 
                this.edituser.perfil.seriesemUsuario[8] > 0 || 
                this.edituser.perfil.seriesemUsuario[9] > 0 || 
                this.edituser.perfil.seriesemUsuario[10] > 0 || 
                this.edituser.perfil.seriesemUsuario[11] > 0 || 
                this.edituser.perfil.seriesemUsuario[12] > 0 ||
                this.edituser.perfil.seriesemUsuario[13] > 0 ||
                this.edituser.perfil.seriesemUsuario[14] > 0){
                return false
              }else{
                return true
              }
          }
        }else{
          if(this.modaluseredit){
            if(this.edituser.perfil.seriesconUsuario[1]>0 ||
            this.edituser.perfil.seriesconUsuario[2]>0 ||
            this.edituser.perfil.seriesconUsuario[3]>0 ||
            this.edituser.perfil.seriesconUsuario[4]>0 ||
            this.edituser.perfil.seriesconUsuario[5]>0 ||
            this.edituser.perfil.seriesconUsuario[6]>0 ||
            this.edituser.perfil.seriesconUsuario[7]>0 ||
            this.edituser.perfil.seriesconUsuario[8]>0 ||
            this.edituser.perfil.seriesconUsuario[9]>0 ||
            this.edituser.perfil.seriesconUsuario[10]>0 ||
            this.edituser.perfil.seriesconUsuario[11]>0 ||
            this.edituser.perfil.seriesconUsuario[12]>0 ||
            this.edituser.perfil.seriesconUsuario[13]>0 ||
            this.edituser.perfil.seriesconUsuario[14]>0){
              return false
            }else{
              return true
            }
          }
        }
        
      }else{
        return false
      }
    },
    validarPassword(){
      let state;
      // number
      let expnumber = new RegExp("([0-9])")
      if(expnumber.test(this.personalizar.claveNueva1)){
        this.number = true
      }else{
        this.number = false
      }
      // Mayus
      let expmayus = new RegExp("([A-Z])")
      if(expmayus.test(this.personalizar.claveNueva1)){
        this.mayus = true;
      }else{
        this.mayus = false
      }
      //Minus
      let expminus = new RegExp("([a-z])")
      if(expminus.test(this.personalizar.claveNueva1)){
        this.minus = true;
      }else{
        this.minus = false;
      }
      //Longitud
      if(this.personalizar.claveNueva1.length >= 6){
        this.longitud = true;
      }else{
        this.longitud = false;
      }
      //Expresion requerida 
      let expreg = new RegExp("([0-9][A-Z]+[a-z])|([0-9][a-z]+[A-Z])|([A-Z][a-z]+[0-9])|([A-Z][0-9]+[a-z])|([a-z][0-9]+[A-Z])|([a-z][A-Z]+[0-9])")
      if(expreg.test(this.personalizar.claveNueva1) && this.personalizar.claveNueva1.length > 5){
        state = true
      }else{
        state = false
      }
        return state;
    },
    mostrarPassword(){
      let tipo = document.getElementById("password");
      let tipo2 = document.getElementById("password2");
      if(tipo.type == "password" && tipo2.type == "password"){
          tipo.type = "text";
          tipo2.type = "text";
      }else{
          tipo.type = "password";
          tipo2.type = "password";
      }
    },
    validarRol(){
      if(this.edituser.perfil.rolUsuario!=1 && this.edituser.perfil.rolUsuario!=3){
        return true
      }
    },
    enviarIGV(variant = null){
      axios
      .post(process.env.VUE_APP_API_URL + 'emisor/configuracion',{
        token: this.$store.getters.userToken,
        igv:this.selectedIGV
      })
      .then(response=>{
        // this.$bvToast.toast('El IGV actual es' + ' ' + this.selectedIGV + '%', {
        // title: 'Nuevo IGV',
        // variant: variant,
        // solid: true
        // }),
        this.$snotify.success('Nuevo IGV registrado' + ' ' + this.selectedIGV + '%', "Éxito")
      })
      .catch(error=>{
        console.log(error)
      })
    },
    getSeriesDoc: function () {
      this.cargandoIgv = true
      let valorIGV = 0
      axios
      .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ 1, {
        token: this.$store.getters.userToken
      })
      .then(response => (
        valorIGV = response.data.igv,
        this.actualIgv(valorIGV)
      ))
      .catch(error => (
       console.log(error)
      ))
    },
    actualIgv(igv){
      this.cargandoIgv = false
      if(igv == 18){
        this.selectedIGV = 18
      }else if(igv == 10.5){
        this.selectedIGV = 10.5
      }
    },
    activarDatos(){
      this.activarInfo = false
      // this.usuarioSol = "",
      // this.claveSol = "",
      // this.clientId = "",
      // this.clientSecret = ""
    },
    validarCamposSunat(){
      if(this.usuarioSol !=null && this.claveSol != null && this.clientId != null && this.clientSecret != null){
        if(this.usuarioSol.length == 8 && this.claveSol.length >=6 && this.clientId.length > 1 && this.clientSecret.length > 1){
           return false
        }else {
          return true  
        }
      }else{
        return true
      }
    },
    credencialesSunat(){
        axios
      .post(process.env.VUE_APP_API_URL + 'usuario/credenciales/sunat/update',{
        token: this.$store.getters.userToken,
        username:this.usuarioSol,
        password:this.claveSol,
        client_id:this.clientId,
        client_secret:this.clientSecret
      })
      .then(response=>(
        this.activarInfo = true,
        this.$snotify.success(response.data.msg, "Exito") 
      ))
      .catch(error=>(
        console.log(error)
      ))
    },
    infoSunat(){
      let datos
      axios
      .post(process.env.VUE_APP_API_URL + 'usuario/credenciales/sunat',{
        token: this.$store.getters.userToken
      })
      .then(response=>(
       datos = response.data.response,
       this.usuarioSol = datos.username,
       this.claveSol = datos.password,
       this.clientId = datos.client_id,
       this.clientSecret = datos.client_secret
      ))
      .catch(error=>(
        console.log('ERROR SUNAT',error)
      ))
      if( this.usuarioSol !='' &&
          this.claveSol !='' &&
          this.clientId !='' &&
          this.clientSecret !=''){
         this.activarInfo = true
      }else{
         this.activarInfo = true
        
      }
    },
    urlOpen(){
      window.open('http://telemovildata.com/producto/Pasos_para_crear_la_llave_en_la_clave_sol.pdf', '_blank');
    },
    cancelar(){
        this.autorizacionTransportista(),
        this.mostrarMtc = true
    },
  }
};
</script>

<style>
.address {
  height: 35px !important;
  margin: 0 !important;
}
.form-label-group {
  position: relative;
  /* margin-bottom: 1rem; */
}

.form-label-group > input,
.form-label-group > label {
  height: 3.125rem;
  padding: 0.75rem;
}

.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0; /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  pointer-events: none;
  cursor: text; /* Match the input under the label */
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: all 0.1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: 1.25rem;
  padding-bottom: 0.25rem;
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 9px;
  color: #00b261;
}
.searcher-field {
  z-index: 1000;
  position: absolute;
  max-height: 400px !important;
  overflow-y: scroll;
  width: 500px;
}
.searcher-result {
  font-size: smaller;
  padding: 2px 0px 2px 0px;
  cursor: pointer;
}
.bordes {
  margin-top: 10px;
  border: 2px solid #ccc;
  border-radius: 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
}
.pagos {
  margin-left: -25px;
  min-height: 310px;
  padding-right: 30px;
}
.negrita {
  font-weight: bold;
  font-size: 14px;
  font-family: "Times New Roman", Times, serif;
}
.list-group-item {
  /* position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: -1px; */
  padding: 0px;
  margin: 0px;
  background-color: #fff;
  border: none;
}
.emisionPersonalizada {
  /* width: 50%; */
}
.estilo{
  background-color:#D5E6FA;
  color:#0454A8;
  border-color:#D5E6FA;
}
.sinresultados{
  padding: 0 5px 0 5px;  
  }
  .botonIgv{
   margin-top: 32px;
  }
  .alinear{
   margin-top: 28px;
  }
  .opUrl{
    cursor:pointer;
    color:rgb(0, 123, 255);
  }
</style>